(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("hls.js"), require("rxjs"));
	else if(typeof define === 'function' && define.amd)
		define(["hls.js", "rxjs"], factory);
	else if(typeof exports === 'object')
		exports["mlb-media-player"] = factory(require("hls.js"), require("rxjs"));
	else
		root["MediaPlayer"] = factory(root["Hls"], root["rxjs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 94);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(34);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var key = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5
};

var webkit = ['webkitFullscreenEnabled', 'webkitFullscreenElement', 'webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitfullscreenchange', 'webkitfullscreenerror'];

var moz = ['mozFullScreenEnabled', 'mozFullScreenElement', 'mozRequestFullScreen', 'mozCancelFullScreen', 'mozfullscreenchange', 'mozfullscreenerror'];

var ms = ['msFullscreenEnabled', 'msFullscreenElement', 'msRequestFullscreen', 'msExitFullscreen', 'MSFullscreenChange', 'MSFullscreenError'];

// so it doesn't throw if no window or document
var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};

var vendor = 'fullscreenEnabled' in document && Object.keys(key) || webkit[0] in document && webkit || moz[0] in document && moz || ms[0] in document && ms || [];

exports.default = {
  requestFullscreen: function requestFullscreen(element) {
    return element[vendor[key.requestFullscreen]]();
  },
  requestFullscreenFunction: function requestFullscreenFunction(element) {
    return element[vendor[key.requestFullscreen]];
  },
  get exitFullscreen() {
    return document[vendor[key.exitFullscreen]].bind(document);
  },
  addEventListener: function addEventListener(type, handler, options) {
    return document.addEventListener(vendor[key[type]], handler, options);
  },
  removeEventListener: function removeEventListener(type, handler, options) {
    return document.removeEventListener(vendor[key[type]], handler, options);
  },
  get fullscreenEnabled() {
    return Boolean(document[vendor[key.fullscreenEnabled]]);
  },
  set fullscreenEnabled(val) {},
  get fullscreenElement() {
    return document[vendor[key.fullscreenElement]];
  },
  set fullscreenElement(val) {},
  get onfullscreenchange() {
    return document[('on' + vendor[key.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(handler) {
    return document[('on' + vendor[key.fullscreenchange]).toLowerCase()] = handler;
  },
  get onfullscreenerror() {
    return document[('on' + vendor[key.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(handler) {
    return document[('on' + vendor[key.fullscreenerror]).toLowerCase()] = handler;
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(13),
    getRawTag = __webpack_require__(36),
    objectToString = __webpack_require__(37);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(20);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(15);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(62);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(5),
    isObjectLike = __webpack_require__(7);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(6);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(45),
    getValue = __webpack_require__(49);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(24),
    eq = __webpack_require__(15);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(22),
    isLength = __webpack_require__(27);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(4),
    isKey = __webpack_require__(35),
    stringToPath = __webpack_require__(38),
    toString = __webpack_require__(66);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(21)))

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(5),
    isObject = __webpack_require__(9);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(12);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(25);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(16),
    copyObject = __webpack_require__(69),
    createAssigner = __webpack_require__(70),
    isArrayLike = __webpack_require__(17),
    isPrototype = __webpack_require__(28),
    keys = __webpack_require__(79);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(93);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(21)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    return defaultLogger;
}));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(19),
    toKey = __webpack_require__(23);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(4),
    isSymbol = __webpack_require__(12);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(13);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(39);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(40);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(41);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(42),
    mapCacheDelete = __webpack_require__(61),
    mapCacheGet = __webpack_require__(63),
    mapCacheHas = __webpack_require__(64),
    mapCacheSet = __webpack_require__(65);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(43),
    ListCache = __webpack_require__(54),
    Map = __webpack_require__(60);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(44),
    hashDelete = __webpack_require__(50),
    hashGet = __webpack_require__(51),
    hashHas = __webpack_require__(52),
    hashSet = __webpack_require__(53);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(8);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(22),
    isMasked = __webpack_require__(46),
    isObject = __webpack_require__(9),
    toSource = __webpack_require__(48);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(47);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(6);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(8);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(8);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(8);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(55),
    listCacheDelete = __webpack_require__(56),
    listCacheGet = __webpack_require__(57),
    listCacheHas = __webpack_require__(58),
    listCacheSet = __webpack_require__(59);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(10);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(10);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(10);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(10);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(6);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(11);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(11);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(11);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(11);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(67);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(13),
    arrayMap = __webpack_require__(68),
    isArray = __webpack_require__(4),
    isSymbol = __webpack_require__(12);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(16),
    baseAssignValue = __webpack_require__(24);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(71),
    isIterateeCall = __webpack_require__(78);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(26),
    overRest = __webpack_require__(72),
    setToString = __webpack_require__(74);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(73);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(75),
    shortOut = __webpack_require__(77);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(76),
    defineProperty = __webpack_require__(25),
    identity = __webpack_require__(26);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(15),
    isArrayLike = __webpack_require__(17),
    isIndex = __webpack_require__(18),
    isObject = __webpack_require__(9);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(80),
    baseKeys = __webpack_require__(90),
    isArrayLike = __webpack_require__(17);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(81),
    isArguments = __webpack_require__(82),
    isArray = __webpack_require__(4),
    isBuffer = __webpack_require__(84),
    isIndex = __webpack_require__(18),
    isTypedArray = __webpack_require__(86);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(83),
    isObjectLike = __webpack_require__(7);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(5),
    isObjectLike = __webpack_require__(7);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(6),
    stubFalse = __webpack_require__(85);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)(module)))

/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(87),
    baseUnary = __webpack_require__(88),
    nodeUtil = __webpack_require__(89);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(5),
    isLength = __webpack_require__(27),
    isObjectLike = __webpack_require__(7);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(20);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29)(module)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(28),
    nativeKeys = __webpack_require__(91);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(92);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(16),
    castPath = __webpack_require__(19),
    isIndex = __webpack_require__(18),
    isObject = __webpack_require__(9),
    toKey = __webpack_require__(23);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/get.js
var lodash_get = __webpack_require__(1);
var get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/loglevel/lib/loglevel.js
var loglevel = __webpack_require__(33);

// CONCATENATED MODULE: ./src/js/util/logger.js

/* harmony default export */ var logger = (loglevel);
// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/set.js
var lodash_set = __webpack_require__(31);
var set_default = /*#__PURE__*/__webpack_require__.n(lodash_set);

// CONCATENATED MODULE: ./src/js/enums/player-type.js
/**
 *
 * @module PlayerType enum
 * @desc Player type enumeration
 *
 */
/* harmony default export */ var player_type = ({
  HTML5: 'HTML5',
  HLSJS: 'HLSJS'
});
// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/fscreen/lib/index.js
var lib = __webpack_require__(2);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(32);

// CONCATENATED MODULE: ./src/js/player/abstract-player.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


/**
 *
 * @module AbstractPlayer
 * @desc Abstract implementation of the MediaPlayer. All concrete player will implement the AbstractPlayer.
 * @class AbstractPlayer
 *
 */

var AbstractPlayer =
/*#__PURE__*/
function () {
  /**
   *
   * @constructor
   * @param {MediaPlayerConfig} mediaPlayerConfig
   *
   */
  function AbstractPlayer(mediaPlayerConfig, observationCenter) {
    _classCallCheck(this, AbstractPlayer);

    /**
     *
     * @type {MediaPlayerConfig}
     * @desc The MediaPlayerConfig object for the player settings and configuration.
     *
     */
    this.mediaPlayerConfig = mediaPlayerConfig;
    /**
     *
     * @type {PlayerTypeConfig}
     * @desc The PlayerTypeConfig object for the player
     *
     */

    this.playerTypeConfig = mediaPlayerConfig.playerTypeConfig;
    /**
     *
     * @type {DOMElement}
     * @desc Reference to the parent element the player will be attached to. Created when the player is
     * initialized and based on the `domTarget` id property passed in via the MediaPlayerConfig.
     *
     */

    this.parentEl = undefined;
    /**
     *
     * @type {DOMElement}
     * @desc The video element created for playback by the concrete implementation.
     *
     */

    this.videoEl = undefined;
    /**
    * @type {ObservationCenter}
    * @desc The Observation Center created by the media player
    */

    this.observationCenter = observationCenter;
  }
  /**
   *
   * @desc Initializes the player and creates the DOM Element
   * @abstract
   *
   */


  _createClass(AbstractPlayer, [{
    key: "initPlayer",
    value: function initPlayer() {
      throw new Error('Implement initPlayer()');
    }
    /**
     *
     * @desc Sets the `parentEl` property with a reference to the player node's parent DOMElement.
     * @abstract
     *
     */

  }, {
    key: "findParentElement",
    value: function findParentElement() {
      throw new Error('Implement findParentElement()');
    }
    /**
     *
     * @desc Creates the player's DOMElement
     * @abstract
     *
     */

  }, {
    key: "createPlayerElement",
    value: function createPlayerElement() {
      throw new Error('Implement createPlayerElement()');
    }
    /**
     *
     * @desc Attaches the player `DOMElement` to the `parentEl`
     * @abstract
     *
     */

  }, {
    key: "attachPlayerElement",
    value: function attachPlayerElement() {
      throw new Error('Implement attachPlayerElement()');
    }
    /**
     *
     * @desc Sets the source of the video for playback
     * @param {MediaItem} mediaItem The MediaItem representing media to play.
     * @abstract
     *
     */

  }, {
    key: "open",
    value: function open(mediaItem) {
      throw new Error("Implement open(media) ".concat(mediaItem));
    }
    /**
     *
     * @desc Replays the current clip
     * @abstract
     *
     */

  }, {
    key: "replay",
    value: function replay() {
      throw new Error('Implement replay()');
    }
    /**
     *
     * @param {string} src The playback URL
     * @abstract
     *
     */

  }, {
    key: "canPlay",
    value: function canPlay(src) {
      throw new Error('Implement canPlay(src)');
    }
    /**
     *
     * @desc Set poster image for the player
     * @param {string} imgUrl
     * @memberof AbstractPlayer
     * @abstract
     *
     */

  }, {
    key: "setPoster",
    value: function setPoster(imgUrl) {
      throw new Error("Implement setPoster(imgUrl) ".concat(imgUrl));
    }
    /**
     *
     * @desc resume playing when paused or stopped
     * @abstract
     *
     */

  }, {
    key: "play",
    value: function play() {
      throw new Error("Implement play()");
    }
    /**
     *
     * @desc Pause playback
     * @abstract
     *
     */

  }, {
    key: "pause",
    value: function pause() {
      throw new Error("Implement pause()");
    }
    /**
     *
     * @desc Pause playback
     * @abstract
     *
     */

  }, {
    key: "seek",
    value: function seek() {
      throw new Error("Implement seek()");
    }
    /**
     *
     * @desc Mute the player
     * @abstract
     *
     */

  }, {
    key: "mute",
    value: function mute() {
      throw new Error("Implement mute()");
    }
    /**
     *
     * @desc Un-mute the player
     * @abstract
     *
     */

  }, {
    key: "unMute",
    value: function unMute() {
      throw new Error("Implement unMute()");
    }
    /**
     *
     * @desc Sets isAdPlaying on the state and updates any observers
     * @param {boolean} value if an ad is playing or not
     * @abstract
     *
     */

  }, {
    key: "setIsAdPlaying",
    value: function setIsAdPlaying(value) {
      throw new Error("Implement setIsAdPlaying(value)");
    }
    /**
     *
     * @desc Abstract. See concrete implementation for details.
     * @param {String} message The message to log.
     * @abstract
     *
     */

  }, {
    key: "log",
    value: function log(message) {
      throw new Error("Implement log(message) ".concat(message));
    }
    /**
     *
     * @desc Abstract. See concrete implementation for details.
     * @abstract
     *
     */

  }, {
    key: "toString",
    value: function toString() {
      throw new Error("Implement toString()");
    }
  }]);

  return AbstractPlayer;
}();

/* harmony default export */ var abstract_player = (AbstractPlayer);
// CONCATENATED MODULE: ./src/js/events/media-player-events.js
/**
 *
 * @module MediaPlayer events enum
 * @desc MediaPlayer event enumeration
 *
 */
/* harmony default export */ var media_player_events = ({
  MEDIA_PLAYER_CREATED: 'MEDIA_PLAYER_CREATED',
  MEDIA_REPLAY: 'MEDIA_REPLAY',
  PLAYER_RESIZED: 'PLAYER_RESIZED'
});
// CONCATENATED MODULE: ./src/js/events/html5-player-events.js
/**
 *
 * @module HTML5 media events enum
 * @desc Media event enumeration
 *
 */
/* harmony default export */ var html5_player_events = ({
  DURATION_CHANGE: 'durationchange',
  MEDIA_COMPLETE: 'ended',
  MEDIA_LOAD_START: 'loadstart',
  CANPLAY: 'canplay',
  MEDIA_LOADED_DATA: 'loadeddata',
  MEDIA_LOADED_META: 'loadedmetadata',
  MEDIA_START: 'play',
  MEDIA_PAUSE: 'pause',
  MEDIA_PLAYING: 'playing',
  MEDIA_SEEKING: 'seeking',
  MEDIA_SEEKED: 'seeked',
  MEDIA_STALLED: 'stalled',
  TIME_UPDATE: 'timeupdate',
  VOLUME_CHANGE: 'volumechange',
  TEXT_TRACKS_AVAILABLE: 'texttracksavailable',
  TEXT_TRACK_ENABLED: 'texttrackenabled',
  TEXT_TRACK_DISABLED: 'texttrackdisabled',
  // TODO: html5 media events
  ABORT: 'abort',
  CANPLAYTHROUGH: 'canplaythrough',
  EMPTIED: 'emptied',
  HTML5_ERROR: 'error',
  // This collided with HLS.ERROR === 'hlsError' that's why `HTML5_ERROR`
  INTERRUPTBEGIN: 'interruptbegin',
  INTERRUPTEND: 'interruptend',
  PROGRESS: 'progress',
  RATECHANGE: 'ratechange',
  SUSPEND: 'suspend',
  WAITING: 'waiting'
});
// EXTERNAL MODULE: external {"commonjs":"hls.js","commonjs2":"hls.js","amd":"hls.js","root":"Hls"}
var external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_ = __webpack_require__(0);
var external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_);

// CONCATENATED MODULE: ./src/js/events/hlsjs-player-events.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/**
 *
 * @module HLSJS media events enum
 * @desc Media event enumeration
 *
 */

/* harmony default export */ var hlsjs_player_events = (_objectSpread({}, html5_player_events, {}, external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events));
// CONCATENATED MODULE: ./src/js/events/events.js



/* harmony default export */ var events = ({
  HTML5: html5_player_events,
  MEDIA_PLAYER: media_player_events,
  HLSJS: hlsjs_player_events
});
// CONCATENATED MODULE: ./src/js/comm/message/base-message.js
function base_message_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 * @module BaseMessage
 * @desc Base message object for messages/events coming out of the unified-player
 * @class BaseMessage
 *
 */
var BaseMessage =
/**
 *
 * @param {string} type The message type
 * @param {Object} mediaPlayer A reference to the current player
 * @param {any} data A message to pass to
 *
 */
function BaseMessage(type) {
  var mediaPlayer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  base_message_classCallCheck(this, BaseMessage);

  /**
   *
   * @type {string}
   *
   */
  this.type = type;
  /**
   *
   * @type {MediaPlayer}
   *
   */

  this.mediaPlayer = mediaPlayer;
  /**
   *
   * @type {MediaPlayer}
   *
   */

  this.data = data;
};

/* harmony default export */ var base_message = (BaseMessage);
// CONCATENATED MODULE: ./src/js/comm/message/event-message.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function event_message_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


/**
 *
 * @module EventMessage
 * @desc Message containing a type and event object
 * @class EveentMessage
 *
 */

var EventMessage =
/*#__PURE__*/
function (_BaseMessage) {
  _inherits(EventMessage, _BaseMessage);

  /**
   *
   * @param {string} type
   * @param {Event} event s
   * @constructor
   *
   */
  function EventMessage(type, event) {
    var _this;

    event_message_classCallCheck(this, EventMessage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EventMessage).call(this, type));
    /**
     *
     * @desc {Event}
     *
     */

    _this.event = event;
    return _this;
  }

  return EventMessage;
}(base_message);

/* harmony default export */ var event_message = (EventMessage);
// CONCATENATED MODULE: ./src/js/comm/message/plugin-ready-message.js
function plugin_ready_message_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugin_ready_message_typeof = function _typeof(obj) { return typeof obj; }; } else { plugin_ready_message_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugin_ready_message_typeof(obj); }

function plugin_ready_message_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function plugin_ready_message_possibleConstructorReturn(self, call) { if (call && (plugin_ready_message_typeof(call) === "object" || typeof call === "function")) { return call; } return plugin_ready_message_assertThisInitialized(self); }

function plugin_ready_message_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function plugin_ready_message_getPrototypeOf(o) { plugin_ready_message_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugin_ready_message_getPrototypeOf(o); }

function plugin_ready_message_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugin_ready_message_setPrototypeOf(subClass, superClass); }

function plugin_ready_message_setPrototypeOf(o, p) { plugin_ready_message_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugin_ready_message_setPrototypeOf(o, p); }


/**
 *
 * @module PluginReadyMessage
 * @desc Message containing a type and event object
 * @class PluginReadyMessage
 *
 */

var PluginReadyMessage =
/*#__PURE__*/
function (_BaseMessage) {
  plugin_ready_message_inherits(PluginReadyMessage, _BaseMessage);

  /**
   *
   * @param {string} type
   * @param {Event} event s
   * @constructor
   *
   */
  function PluginReadyMessage(type, plugin) {
    var _this;

    plugin_ready_message_classCallCheck(this, PluginReadyMessage);

    _this = plugin_ready_message_possibleConstructorReturn(this, plugin_ready_message_getPrototypeOf(PluginReadyMessage).call(this, type));
    /**
     *
     * @desc {Event}
     *
     */

    _this.plugin = plugin;
    return _this;
  }

  return PluginReadyMessage;
}(base_message);

/* harmony default export */ var plugin_ready_message = (PluginReadyMessage);
// CONCATENATED MODULE: ./src/js/comm/message/state-event-message.js
function state_event_message_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { state_event_message_typeof = function _typeof(obj) { return typeof obj; }; } else { state_event_message_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return state_event_message_typeof(obj); }

function state_event_message_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function state_event_message_possibleConstructorReturn(self, call) { if (call && (state_event_message_typeof(call) === "object" || typeof call === "function")) { return call; } return state_event_message_assertThisInitialized(self); }

function state_event_message_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function state_event_message_getPrototypeOf(o) { state_event_message_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return state_event_message_getPrototypeOf(o); }

function state_event_message_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) state_event_message_setPrototypeOf(subClass, superClass); }

function state_event_message_setPrototypeOf(o, p) { state_event_message_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return state_event_message_setPrototypeOf(o, p); }


/**
 *
 * @module StateEventMessage
 * @desc Message containing a type and event object
 * @class StateEventMessage
 *
 */

var StateEventMessage =
/*#__PURE__*/
function (_BaseMessage) {
  state_event_message_inherits(StateEventMessage, _BaseMessage);

  /**
   *
   * @param {string} type
   * @param {Event} event s
   * @constructor
   *
   */
  function StateEventMessage(type, event, stateModel) {
    var _this;

    state_event_message_classCallCheck(this, StateEventMessage);

    _this = state_event_message_possibleConstructorReturn(this, state_event_message_getPrototypeOf(StateEventMessage).call(this, type));
    /**
     *
     * @desc {Event}
     *
     */

    _this.event = event;
    /**
     *
     * @desc the model representing the current player state
     *
     */

    _this.stateModel = stateModel;
    return _this;
  }

  return StateEventMessage;
}(base_message);

StateEventMessage.PLAYER_STATE_UPDATE = 'PLAYER_STATE_UPDATE';
StateEventMessage.PLAYER_TIME_STATE_UPDATE = 'PLAYER_TIME_STATE_UPDATE';
/* harmony default export */ var state_event_message = (StateEventMessage);
// CONCATENATED MODULE: ./src/js/comm/message/messages.js




/* harmony default export */ var messages = ({
  BaseMessage: base_message,
  EventMessage: event_message,
  PluginReadyMessage: plugin_ready_message,
  StateEventMessage: state_event_message
});
// CONCATENATED MODULE: ./src/js/util/cache-manager.js
function cache_manager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cache_manager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function cache_manager_createClass(Constructor, protoProps, staticProps) { if (protoProps) cache_manager_defineProperties(Constructor.prototype, protoProps); if (staticProps) cache_manager_defineProperties(Constructor, staticProps); return Constructor; }

var SessionCache =
/*#__PURE__*/
function () {
  function SessionCache() {
    cache_manager_classCallCheck(this, SessionCache);

    this.objectPrefix = 'object!';
  }

  cache_manager_createClass(SessionCache, [{
    key: "set",
    value: function set(key, value) {
      if (typeof value !== 'string') {
        value = this.objectPrefix + JSON.stringify(value);
      }

      sessionStorage.setItem(key, value);
    }
  }, {
    key: "get",
    value: function get(key) {
      var value = sessionStorage.getItem(key) || "";

      if (value.indexOf(this.objectPrefix) === 0) {
        value = JSON.parse(value.substr(this.objectPrefix.length));
      }

      return value;
    }
  }, {
    key: "remove",
    value: function remove(key) {
      sessionStorage.removeItem(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      sessionStorage.clear();
    }
  }]);

  return SessionCache;
}();

var sessionCache = new SessionCache();
// CONCATENATED MODULE: ./src/js/util/feature-detection.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function feature_detection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function feature_detection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function feature_detection_createClass(Constructor, protoProps, staticProps) { if (protoProps) feature_detection_defineProperties(Constructor.prototype, protoProps); if (staticProps) feature_detection_defineProperties(Constructor, staticProps); return Constructor; }



var feature_detection_FeatureDetection =
/*#__PURE__*/
function () {
  function FeatureDetection() {
    feature_detection_classCallCheck(this, FeatureDetection);
  }

  feature_detection_createClass(FeatureDetection, [{
    key: "setCachedFeature",
    value: function setCachedFeature(name, value) {
      sessionCache.set(name, value);
    }
  }, {
    key: "getCachedFeature",
    value: function getCachedFeature(name) {
      sessionCache.get(name);
    }
    /**
     *
     * @desc Instantiates a video tag into the document and tries to start video playback.
     * @returns { Boolean }
     *
     */

  }, {
    key: "testAutoPlay",
    value: function testAutoPlay(muted) {
      var _this = this;

      var cacheKey = "autoplay-".concat(muted ? 'muted' : 'unmuted');
      var cachedValue = this.getCachedFeature(cacheKey);

      if (cachedValue) {
        return cachedValue;
      }

      var id = new Date().getTime();
      var style = ["position: absolute", "left: 0", "bottom: 0", "width: 1px", "height: 1px"].join(";");
      var videoEl = document.createElement('video');
      videoEl.setAttribute('id', "autoPlayVideoPlayerTest_".concat(id));
      videoEl.setAttribute('src', 'https://www.mlbstatic.com/mlb.com/mlbtv/video/autoplay-test.mp4');
      videoEl.setAttribute('style', style);
      videoEl.setAttribute('crossOrigin', 'anonymous');
      videoEl.controls = false;
      videoEl.autoplay = false;
      videoEl.loop = false;
      videoEl.muted = muted;
      videoEl.playsinline = true;
      document.body.appendChild(videoEl);
      videoEl.volume = muted ? 0 : 0.1;
      var playbackPromise;
      /**
       * IE & Edge don't have the same behavior
       * Good browsers will reject the promise, MS ones will throw an error
       */

      try {
        playbackPromise = videoEl.play().then(function () {
          return true;
        });
      } catch (e) {
        /** We're catching for IE & Edge, we'll assume they're good to go */
        playbackPromise = Promise.resolve(true);
        this.removeChildNode(videoEl);
      }

      return playbackPromise.then(function () {
        var hasPassed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        _this.removeChildNode(videoEl);

        _this.setCachedFeature(cacheKey, hasPassed);

        return Promise.resolve(hasPassed);
      }).catch(function () {
        _this.removeChildNode(videoEl);

        return false;
      });
    }
  }, {
    key: "removeChildNode",
    value: function removeChildNode(childNode) {
      var parentNode = childNode.parentNode;

      if (parentNode) {
        parentNode.removeChild(childNode);
      }
    }
    /**
     *
     * Utility function to check if the device supports autoplay in HTML5 videos
     * @returns { Boolean }
     *
     */

  }, {
    key: "testHTML5Autoplay",
    value: function testHTML5Autoplay() {
      return Promise.all([this.testAutoPlay(false),
      /** Test unmuted autoplay video */
      this.testAutoPlay(true)
      /** Test muted autoplay video */
      ]).then(function formatResponse(_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            regular = _ref2[0],
            muted = _ref2[1];

        return {
          regular: regular,
          muted: muted
        };
      });
    }
  }]);

  return FeatureDetection;
}();

/* harmony default export */ var feature_detection = (new feature_detection_FeatureDetection());
// EXTERNAL MODULE: external {"root":["rxjs"],"commonjs":"rxjs","commonjs2":"rxjs","amd":"rxjs"}
var external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_ = __webpack_require__(3);

// CONCATENATED MODULE: ./src/js/state/state-model.js
function state_model_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function state_model_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function state_model_createClass(Constructor, protoProps, staticProps) { if (protoProps) state_model_defineProperties(Constructor.prototype, protoProps); if (staticProps) state_model_defineProperties(Constructor, staticProps); return Constructor; }

/**
 *
 * @class StateModel
 * @desc A model representing the state of the player at any given moment
 * @module StateModel
 *
 */
var StateModel =
/*#__PURE__*/
function () {
  /**
   *
   * @constructor
   *
   */
  function StateModel() {
    state_model_classCallCheck(this, StateModel);

    /**
     *
     * @type {boolean}
     * @desc If the player is playing or not
     *
     */
    this.playing = false;
    /**
     *
     * @type {boolean}
     * @desc If the player is paused or not
     *
     */

    this.paused = true;
    /**
     *
     * @type {boolean}
     * @desc If the player has stopped. Stopped means has played through and returned to the beginning (replay) or `MEDIA_COMPLETE` event.
     *
     */

    this.stopped = true;
    /**
     *
     * @type {boolean}
     * @desc If the player is in a "loading" state. Loading state is 1) not playing and 2) loading data to be ready to play
     *
     */

    this.loading = false;
    /**
     *
     * @type {boolean}
     * @desc The media has started playback. Set `true` on the `MEDIA_START` event
     *
     */

    this.mediaStarted = false;
    /**
     *
     * @type {object}
     * @desc Representation of the volume. The object contains 3 properties
     * 1. value: {number} The value of the current volume setting 0 - 1.
     * 2. muted: {boolean} If the player is muted or not.
     * 3. lastValue: {number} The value of the last volume setting 0 - 1.
     *
     */

    this.volume = {
      value: 1,
      muted: false,
      lastValue: 1
    };
    /**
     *
     * @type {number}
     * @desc The buffered amount in seconds.
     *
     */

    this.bufferedValue = 0;
    /**
     *
     * @type {boolean}
     * @desc If an ad is playing or not (not used currently).
     *
     */

    this.isAdPlaying = false;
    /**
     *
     * @type {boolean}
     * @desc If fullscreen is enabled by browser or user settings or not.
     *
     */

    this.isFullscreenEnabled = true;
    /**
     *
     * @type {boolean}
     * @desc If the player is in fullscreen mode or not.
     *
     */

    this.isFullscreen = false;
    /**
     *
     * @type {ArrayLike object}
     * @desc Keeps closed captions tracks in the state
     *
     */

    this.closedCaptions = {};
    /**
     *
     * @type {boolean}
     * @desc Determines whether closed captions are turned on or off
     *
     */

    this.closedCaptionsActive = false;
    /**
     *
     * @type {boolean}
     * @desc If the media is audio only or not (not used currently).
     *
     */

    this.isAudioOnly = false;
    /**
     *
     * @type {*}
     * @desc The currently selected audio track (not currently used).
     *
     */

    this.selectedAudioTrack = undefined;
    /**
     *
     * @type {number}
     * @desc The currently selected bitrate (not currently used).
     *
     */

    this.selectedBitRate = -1;
  }
  /**
   *
   * @param {boolean} isLoading
   * @desc If the player is in a loading state or not
   *
   */


  state_model_createClass(StateModel, [{
    key: "setLoadingState",
    value: function setLoadingState(isLoading) {
      this.loading = isLoading;
    }
    /**
     *
     * @param {number} volume The current volume between 0 and 1
     * @param {boolean} muted If the player is muted or not
     * @desc Sets the player state when the `MEDIA_START` event is received. In addition to setting
     * `playing` to `true`, `paused` to `false`, & `stopped` to `false`, `mediaStarted` is set to `true`.
     *
     */

  }, {
    key: "setMediaStartState",
    value: function setMediaStartState(volume, muted) {
      this.playing = true;
      this.paused = false;
      this.stopped = false;
      this.mediaStarted = true; // Also set the initial volume state

      this.volume.value = volume || this.volume.value;
      this.volume.muted = muted || this.volume.muted;
    }
    /**
     *
     * @desc Sets the player sate when the MEDIA_PAUSE event is dispatched
     *
     */

  }, {
    key: "setMediaPauseState",
    value: function setMediaPauseState() {
      this.playing = false;
      this.paused = true;
      this.stopped = false;
    }
    /**
     *
     * @desc Sets the player sate when the MEDIA_COMPLETE event is dispatched
     *
     */

  }, {
    key: "setMediaCompleteState",
    value: function setMediaCompleteState() {
      this.playing = false;
      this.paused = true;
      this.stopped = true;
    }
    /**
     *
     * @desc Set the volume. When setting the volume, capture muted and previous volume.
     * @param {number} volume The volume
     * @param {boolean} muted If the player is muted or not
     *
     */

  }, {
    key: "setVolumeChangeState",
    value: function setVolumeChangeState(volume, muted) {
      this.volume.lastValue = this.volume.value;
      this.volume.value = volume;
      this.volume.muted = muted;
    }
    /**
     *
     * @desc Set isFullscreen state data
     *
     */

  }, {
    key: "setFullscreenChangeState",
    value: function setFullscreenChangeState(isFullscreen, isFullscreenEnabled) {
      this.isFullscreen = isFullscreen;
      this.isFullscreenEnabled = isFullscreenEnabled;
    }
    /**
     *
     * @desc Update adIsPlaying
     * @param {boolean} adIsPlaying If an ad is playing or not
     *
     */

  }, {
    key: "setIsAdPlayingState",
    value: function setIsAdPlayingState(adIsPlaying) {
      this.isAdPlaying = adIsPlaying;
    }
    /**
     *
     * @desc Update closedCaptions
     * @param {array-like} vttItems List of vttItems or text tracks
     *
     */

  }, {
    key: "setClosedCaptions",
    value: function setClosedCaptions(vttItems) {
      this.closedCaptions = vttItems || {};
    }
    /**
     *
     * @desc Update closedCaptionsActive
     * @param {boolean} ccActive If closed captions are showing
     *
     */

  }, {
    key: "setClosedCaptionsActiveState",
    value: function setClosedCaptionsActiveState(ccActive) {
      this.closedCaptionsActive = ccActive;
    }
  }]);

  return StateModel;
}();

/* harmony default export */ var state_model = (StateModel);
// CONCATENATED MODULE: ./src/js/state/time-state-model.js
function time_state_model_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function time_state_model_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function time_state_model_createClass(Constructor, protoProps, staticProps) { if (protoProps) time_state_model_defineProperties(Constructor.prototype, protoProps); if (staticProps) time_state_model_defineProperties(Constructor, staticProps); return Constructor; }

/**
 *
 * @class TimeStateModel
 * @desc A model representing the time related state of the player at any given moment
 * @module TimeStateModel
 *
 */
var TimeStateModel =
/*#__PURE__*/
function () {
  /**
   *
   * @constructor
   *
   */
  function TimeStateModel() {
    time_state_model_classCallCheck(this, TimeStateModel);

    /**
     *
     * @type {boolean}
     * @desc If the media is Live (`true`) or VOD (`false`)
     *
     */
    this.isLive = false;
    /**
     *
     * @type {boolean}
     * @desc If the live media is at live point or not. `false` unless `isLive` is `true` and the media is at live point or within an acceptable range of the live point.
     *
     */

    this.isAtLivePoint = false;
    /**
     *
     * @type {number}
     * @desc The current time of playback in seconds.
     *
     */

    /**
     *
     * @type {object}
     * @desc describe the range of media that its seekable
     *
     */

    this.seekableRange = {
      start: 0,
      end: 0
    };
    this.currentTime = 0;
    /**
     *
     * @type {number}
     * @desc The duration of the media in seconds.
     *
     */

    this.duration = 0;
    /**
     *
     * @type {number}
     * @desc The buffered amount in seconds.
     *
     */

    this.bufferedValue = 0;
    /**
     *
     * @type {boolean}
     * @desc If the player is seeking or not.
     *
     */

    this.seeking = false;
  }
  /**
   *
   * @desc Sets the player sate when the MEDIA_SEEKED event is dispatched
   *
   */


  time_state_model_createClass(TimeStateModel, [{
    key: "setMediaSeekedState",
    value: function setMediaSeekedState() {
      this.seeking = false;
    }
    /**
     *
     * @desc Sets the player sate when the MEDIA_SEEKING event is dispatched
     *
     */

  }, {
    key: "setMediaSeekingState",
    value: function setMediaSeekingState() {
      this.seeking = true;
    }
    /**
     *
     * @desc Sets the player sate when the TIME_UPDATE event is dispatched
     * @param {number} currentTime The current time in seconds
     *
     */

  }, {
    key: "setMediaTimeupdateState",
    value: function setMediaTimeupdateState(currentTime) {
      this.currentTime = currentTime;

      if (this.isLive) {
        this.updateIsAtLivePoint();
      }
    }
    /**
     *
     * @desc Set the player state when the DURATION_CHANGE event is dispatched
     * @param {number} duration The duration in seconds
     *
     */

  }, {
    key: "setMediaDurationChangeState",
    value: function setMediaDurationChangeState(duration) {
      this.duration = duration;
      this.updateSeekableRange(this.duration);

      if (this.isLive) {
        this.updateIsAtLivePoint();
      }
    }
    /**
     *
     * @desc Set the player state when the DURATION_CHANGE event is dispatched
     * @param {boolean} isLive
     *
     */

  }, {
    key: "setLevelLoadedState",
    value: function setLevelLoadedState(isLive, targetduration, streamStart) {
      this.isLive = isLive;
      this.targetduration = targetduration;
      this.seekableRange.start = streamStart;
    }
    /**
     *
     * @desc Update Seekable range
     * @param {number} duration the duration used to calculate the seekable range end
     * @todo modify the start of the seekable range on sliding window streams
     */

  }, {
    key: "updateSeekableRange",
    value: function updateSeekableRange(duration) {
      if (this.isLive) {
        //this is a calculation sugested by the HLS.JS team, this provides the latest safe point to seek to on live streams
        this.seekableRange.end = duration - 3 * this.targetduration;
      } else {
        // for VOD content the end of the seekableRange its the duration of the stream
        this.seekableRange.end = duration;
      }
    }
    /**
     *
     * @desc Update isAtLivePoint based on the current time
     *
     */

  }, {
    key: "updateIsAtLivePoint",
    value: function updateIsAtLivePoint() {
      //check if we need to update the isAtLivePoint property, i took the 8 from bam-hls implementation
      // @todo make this configurable
      this.isAtLivePoint = this.seekableRange.end - this.currentTime < 8;
    }
  }]);

  return TimeStateModel;
}();

/* harmony default export */ var time_state_model = (TimeStateModel);
// CONCATENATED MODULE: ./src/js/player/base-player.js
function base_player_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { base_player_typeof = function _typeof(obj) { return typeof obj; }; } else { base_player_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return base_player_typeof(obj); }

function base_player_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function base_player_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function base_player_createClass(Constructor, protoProps, staticProps) { if (protoProps) base_player_defineProperties(Constructor.prototype, protoProps); if (staticProps) base_player_defineProperties(Constructor, staticProps); return Constructor; }

function base_player_possibleConstructorReturn(self, call) { if (call && (base_player_typeof(call) === "object" || typeof call === "function")) { return call; } return base_player_assertThisInitialized(self); }

function base_player_getPrototypeOf(o) { base_player_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return base_player_getPrototypeOf(o); }

function base_player_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function base_player_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) base_player_setPrototypeOf(subClass, superClass); }

function base_player_setPrototypeOf(o, p) { base_player_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return base_player_setPrototypeOf(o, p); }

/**
 *
 * @module BasePlayer
 * @desc Base implementation of a concrete player
 * @class BasePlayer
 *
 */












var base_player_BasePlayer =
/*#__PURE__*/
function (_AbstractPlayer) {
  base_player_inherits(BasePlayer, _AbstractPlayer);

  function BasePlayer(config, observationCenter) {
    var _this;

    base_player_classCallCheck(this, BasePlayer);

    _this = base_player_possibleConstructorReturn(this, base_player_getPrototypeOf(BasePlayer).call(this, config, observationCenter));

    _this.log('BasePlayer constructor', config);

    _this.onPlayerResize = _this.onPlayerResize.bind(base_player_assertThisInitialized(_this));
    _this.stateModel = new state_model();
    _this.timeStateModel = new time_state_model();
    _this.resizeObserver = new ResizeObserver_es["a" /* default */](_this.onPlayerResize);
    _this.subscriptions = [];
    /**
     *
     * @type {MediaItem}
     * @desc the currrently playing media item
     *
     */

    _this.currentMediaItem = undefined;
    return _this;
  }
  /**
   *
   * @desc Detects supported features in the current browser
   *
   */


  base_player_createClass(BasePlayer, [{
    key: "detectFeatures",
    value: function detectFeatures() {
      var _this2 = this;

      this.log('Detect features');
      return feature_detection.testHTML5Autoplay().then(function (autoplay) {
        _this2.log('features', autoplay);

        _this2.features = {
          autoplay: autoplay
        };
      });
    }
    /**
     *
     * @desc Initializes the player and creates the DOM Element(s). Calls
     * 1. findParentElement()
     * 2. createPlayerElement()
     * 3. subscribeEvents() the events from the Player to the channel
     * 3. attachPlayerElement()
     *
     */

  }, {
    key: "initPlayer",
    value: function initPlayer() {
      var _this3 = this;

      return this.detectFeatures().then(function () {
        _this3.setAutoplayConfig();

        _this3.findParentElement();

        _this3.createPlayerElement();

        _this3.attachPlayerElement();

        _this3.subscribe();

        _this3.initListeners();

        var mediaItem = get_default()(_this3.playerTypeConfig, 'mediaItem');

        if (mediaItem && mediaItem.src) {
          _this3.open(mediaItem);
        }
      });
    }
    /**
     *
     * @desc Sets/updates the autoPlay config
     *
     */

  }, {
    key: "setAutoplayConfig",
    value: function setAutoplayConfig() {
      var _this$playerTypeConfi = this.playerTypeConfig,
          autoplayConfig = _this$playerTypeConfi.autoPlay,
          clickToPlay = _this$playerTypeConfi.clickToPlay;

      var regularFeatures = get_default()(this.features, 'autoplay.regular', false);

      var mutedFeatures = get_default()(this.features, 'autoplay.muted', false);

      var forceMutedPlayer = !regularFeatures && mutedFeatures && !clickToPlay;
      /** Then change the muted property based on this */

      if (forceMutedPlayer) {
        this.playerTypeConfig.mute = true;
      }

      this.stateModel.setVolumeChangeState(1, this.playerTypeConfig.mute);
    }
    /**
     *
     * @desc Sets the `parentEl` property with a reference to the player node's parent `DOMElement`.
     * The reference to the parent node is based on the `someTarget` passed in with the `MediaPlayerConfig`
     *
     */

  }, {
    key: "findParentElement",
    value: function findParentElement() {
      this.parentEl = document.getElementById(this.playerTypeConfig.domTarget);
    }
    /**
     *
     * @desc Request fullscreen for the specified DOM element
     * @param {*} element The DOM element to target for fullscreen
     *
     */

  }, {
    key: "requestFullscreen",
    value: function requestFullscreen(element) {
      this.log('Request fullscreen');
      lib_default.a.requestFullscreen(element);
    }
    /**
     *
     * @desc Exit fullscreen
     *
     */

  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      this.log('exit fullscreen');
      lib_default.a.exitFullscreen();
    }
    /**
     *
     * @desc Logs the message to the console.
     * @param {String} message The message to log.
     * @param {*} object An object to send to the console
     *
     */

  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var message = args.shift();
      var name = this.toString();
      logger.log("".concat(name, ": ").concat(message), args);
    }
    /**
     *
     * @desc Setup event listeners
     *
     */

  }, {
    key: "initListeners",
    value: function initListeners() {
      if (lib_default.a.fullscreenEnabled) {
        lib_default.a.addEventListener('fullscreenchange', this.onFullscreenChange.bind(this));
        lib_default.a.addEventListener('fullscreenerror', this.onFullscreenChange.bind(this));
      }

      this.resizeObserver.observe(this.parentEl.parentNode);
    }
    /**
     *
     * @desc Fullscreen change handler. Set the player state when the player enters or exits fullscreen
     * @param {Event} event
     *
     */

  }, {
    key: "onFullscreenChange",
    value: function onFullscreenChange(event) {
      var hasFullscreenElement = !!lib_default.a.fullscreenElement;
      this.stateModel.setFullscreenChangeState(hasFullscreenElement, lib_default.a.fullscreenEnabled);
      this.observationCenter.stateSubject.next(new messages.StateEventMessage(messages.StateEventMessage.PLAYER_STATE_UPDATE, null, this.stateModel));
    }
  }, {
    key: "onFullscreenError",
    value: function onFullscreenError(event) {
      this.log('There was a Fullscreen error ', event);
    }
  }, {
    key: "onPlayerResize",
    value: function onPlayerResize(entries) {
      var newSize = entries[0].contentRect;
      this.observationCenter.playerSubject.next(new messages.BaseMessage(events.MEDIA_PLAYER.PLAYER_RESIZED, null, newSize));
    }
  }, {
    key: "updateStateSubject",
    value: function updateStateSubject(message) {
      if (message.type !== 'empty') {
        var stateSubject = this.observationCenter.stateSubject;
        stateSubject.next(new messages.StateEventMessage(messages.StateEventMessage.PLAYER_STATE_UPDATE, message, this.stateModel));
      }
    }
  }, {
    key: "updatePlayerTimeSubject",
    value: function updatePlayerTimeSubject(message) {
      if (message.type !== 'empty') {
        var playerTimeSubject = this.observationCenter.playerTimeSubject;
        playerTimeSubject.next(new messages.StateEventMessage(messages.StateEventMessage.PLAYER_TIME_STATE_UPDATE, message, this.timeStateModel));
      }
    }
    /**
     *
     * @desc Subscribe to player events
     *
     */

  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this4 = this;

      var PlayerEvents = this.getPlayerEvents(this.playerTypeConfig.playerType);
      var playerSubject = this.observationCenter.playerSubject;
      var subscription = playerSubject.subscribe(function (message) {
        var type = message.type;

        switch (type) {
          case PlayerEvents.MEDIA_LOAD_START:
            {
              _this4.stateModel.setLoadingState(true);

              _this4.updateStateSubject(message);

              break;
            }

          case PlayerEvents.CANPLAY:
            {
              _this4.stateModel.setLoadingState(false);

              _this4.updateStateSubject(message);

              break;
            }

          case PlayerEvents.MEDIA_START:
            {
              var volume = get_default()(message, 'event.target.volume');

              var muted = get_default()(message, 'event.target.muted');

              _this4.stateModel.setMediaStartState(volume, muted);

              _this4.updateStateSubject(message);

              break;
            }

          case PlayerEvents.MEDIA_PAUSE:
            {
              _this4.stateModel.setMediaPauseState();

              _this4.updateStateSubject(message);

              break;
            }

          case PlayerEvents.MEDIA_COMPLETE:
            {
              _this4.stateModel.setMediaCompleteState();

              _this4.updateStateSubject(message);

              break;
            }

          case PlayerEvents.MEDIA_SEEKED:
            {
              _this4.timeStateModel.setMediaSeekedState();

              _this4.updatePlayerTimeSubject(message);

              break;
            }

          case PlayerEvents.MEDIA_SEEKING:
            {
              _this4.timeStateModel.setMediaSeekingState();

              _this4.updatePlayerTimeSubject(message);

              break;
            }

          case PlayerEvents.TIME_UPDATE:
            {
              _this4.timeStateModel.setMediaTimeupdateState(get_default()(message, 'event.target.currentTime'));

              _this4.updatePlayerTimeSubject(message);

              break;
            }

          case PlayerEvents.DURATION_CHANGE:
            {
              _this4.timeStateModel.setMediaDurationChangeState(get_default()(message, 'event.target.duration'));

              _this4.updatePlayerTimeSubject(message);

              break;
            }

          case PlayerEvents.VOLUME_CHANGE:
            {
              var _volume = get_default()(message, 'event.target.volume');

              var _muted = get_default()(message, 'event.target.muted');

              _this4.stateModel.setVolumeChangeState(_volume, _muted);

              _this4.updateStateSubject(message);

              break;
            }

          case PlayerEvents.LEVEL_LOADED:
            {
              var live = get_default()(message, 'data.details.live');

              var targetDuration = get_default()(message, 'data.details.targetduration');

              var streamStart = get_default()(message, 'data.details.fragments[0].start');

              _this4.timeStateModel.setLevelLoadedState(live, targetDuration, streamStart);

              _this4.updatePlayerTimeSubject(message);

              break;
            }

          case PlayerEvents.TEXT_TRACKS_AVAILABLE:
            {
              _this4.stateModel.setClosedCaptions(message.data);

              _this4.updateStateSubject(message);

              break;
            }

          case PlayerEvents.TEXT_TRACK_ENABLED:
            {
              _this4.stateModel.setClosedCaptionsActiveState(true);

              _this4.updateStateSubject(message);

              break;
            }

          case PlayerEvents.TEXT_TRACK_DISABLED:
            {
              _this4.stateModel.setClosedCaptionsActiveState(false);

              _this4.updateStateSubject(message);

              break;
            }
        }
      });
      this.subscriptions.push(subscription);
    }
    /**
     *
     * @desc Unsubscribe from any subjects
     *
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
    /**
     *
     * @desc Get the player events based on the config.
     * @param {String} type The player type to get events for
     *
     */

  }, {
    key: "getPlayerEvents",
    value: function getPlayerEvents(type) {
      return events[type];
    }
    /**
     *
     * @desc Play media when paused or stopped
     *
     */

  }, {
    key: "play",
    value: function play() {
      this.videoEl.play();
    }
    /**
     *
     * @desc Pause media playback
     *
     */

  }, {
    key: "pause",
    value: function pause() {
      this.videoEl.pause();
    }
    /**
     *
     * @desc Sets the currentTime to 0.
     *
     */

  }, {
    key: "replay",
    value: function replay() {
      this.videoEl.currentTime = 0;
      this.videoEl.play();
    }
    /**
     *
     * @description Set poster image for the HTML5 player
     * @param {string} imgUrl
     * @memberof HLSJSPlayer
     *
     */

  }, {
    key: "setPoster",
    value: function setPoster(imgUrl) {
      this.videoEl.setAttribute('poster', imgUrl);
    }
    /**
     *
     * @desc Seek to the specified time
     * @param {Number} time The time to seek to
     *
     */

  }, {
    key: "seek",
    value: function seek(time) {
      this.videoEl.currentTime = time;
    }
    /**
     *
     * @desc Mute the player
     *
     */

  }, {
    key: "mute",
    value: function mute() {
      this.videoEl.muted = true;
    }
    /**
     *
     * @desc Mute the player
     *
     */

  }, {
    key: "unMute",
    value: function unMute() {
      this.videoEl.muted = false;
    }
    /**
     *
     * @desc Sets the player volume
     * @param {number} volume The volume to set the player to. A value between 0 and 1.
     *
     */

  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.videoEl.volume = volume;
    }
    /**
     *
     * @desc Sets isAdPlaying on the state and updates any observers
     * @param {boolean} value if an ad is playing or not
     *
     */

  }, {
    key: "setIsAdPlaying",
    value: function setIsAdPlaying(value) {
      this.stateModel.setIsAdPlayingState(value);
      this.observationCenter.stateSubject.next(new messages.StateEventMessage(messages.StateEventMessage.PLAYER_STATE_UPDATE, null, this.stateModel));
    }
    /**
     *
     * @desc Destroys the BasePlayer
     *
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.unsubscribe();
      lib_default.a.removeEventListener('fullscreenchange', this.onFullscreenChange);
      lib_default.a.removeEventListener('fullscreenerror', this.onFullscreenError);

      if (this.parentEl) {
        this.resizeObserver.unobserve(this.parentEl);
      }
    }
    /**
     *
     * @desc Returns the object type as a string
     * @abstract
     *
     */

  }, {
    key: "toString",
    value: function toString() {
      return 'BasePlayer';
    }
  }]);

  return BasePlayer;
}(abstract_player);

/* harmony default export */ var base_player = (base_player_BasePlayer);
// CONCATENATED MODULE: ./src/js/comm/message/html5-media-message.js
function html5_media_message_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { html5_media_message_typeof = function _typeof(obj) { return typeof obj; }; } else { html5_media_message_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return html5_media_message_typeof(obj); }

function html5_media_message_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function html5_media_message_possibleConstructorReturn(self, call) { if (call && (html5_media_message_typeof(call) === "object" || typeof call === "function")) { return call; } return html5_media_message_assertThisInitialized(self); }

function html5_media_message_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function html5_media_message_getPrototypeOf(o) { html5_media_message_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return html5_media_message_getPrototypeOf(o); }

function html5_media_message_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) html5_media_message_setPrototypeOf(subClass, superClass); }

function html5_media_message_setPrototypeOf(o, p) { html5_media_message_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return html5_media_message_setPrototypeOf(o, p); }


/**
 *
 * @module HTML5MediaMessage
 * @desc Message containing a type and event object
 * @class HTML5MediaMessage
 *
 */

var HTML5MediaMessage =
/*#__PURE__*/
function (_BaseMessage) {
  html5_media_message_inherits(HTML5MediaMessage, _BaseMessage);

  /**
   *
   * @param {string} type
   * @param {Event} event
   * @constructor
   *
   */
  function HTML5MediaMessage(type, event, data) {
    var _this;

    html5_media_message_classCallCheck(this, HTML5MediaMessage);

    _this = html5_media_message_possibleConstructorReturn(this, html5_media_message_getPrototypeOf(HTML5MediaMessage).call(this, type, null, data));
    /**
     *
     * @type {Event}
     * @desc The event to be passed though
     *
     */

    _this.event = event;
    _this.data = data;
    return _this;
  }

  return HTML5MediaMessage;
}(base_message);

/* harmony default export */ var html5_media_message = (HTML5MediaMessage);
// CONCATENATED MODULE: ./src/js/player/html5/html5-player.js
function html5_player_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { html5_player_typeof = function _typeof(obj) { return typeof obj; }; } else { html5_player_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return html5_player_typeof(obj); }

function html5_player_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function html5_player_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function html5_player_createClass(Constructor, protoProps, staticProps) { if (protoProps) html5_player_defineProperties(Constructor.prototype, protoProps); if (staticProps) html5_player_defineProperties(Constructor, staticProps); return Constructor; }

function html5_player_possibleConstructorReturn(self, call) { if (call && (html5_player_typeof(call) === "object" || typeof call === "function")) { return call; } return html5_player_assertThisInitialized(self); }

function html5_player_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get2(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get2 = Reflect.get; } else { _get2 = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get2(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = html5_player_getPrototypeOf(object); if (object === null) break; } return object; }

function html5_player_getPrototypeOf(o) { html5_player_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return html5_player_getPrototypeOf(o); }

function html5_player_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) html5_player_setPrototypeOf(subClass, superClass); }

function html5_player_setPrototypeOf(o, p) { html5_player_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return html5_player_setPrototypeOf(o, p); }





/**
 *
 * @module HTML5Player
 * @desc Concrete HTML5 video player implementation
 * @class HTML5Player
 *
 */

var html5_player_HTML5Player =
/*#__PURE__*/
function (_BasePlayer) {
  html5_player_inherits(HTML5Player, _BasePlayer);

  /**
   *
   * @constructor
   * @param {MediaPlayerConfig} mediaPlayerConfig The MediaPlayerConfig object. Contains the PlayerTypeConfig object used to construct the `<video/>` node.
   *
   */
  function HTML5Player(mediaPlayerConfig, observationCenter) {
    var _this;

    html5_player_classCallCheck(this, HTML5Player);

    _this = html5_player_possibleConstructorReturn(this, html5_player_getPrototypeOf(HTML5Player).call(this, mediaPlayerConfig, observationCenter));
    /**
     *
     * @type {Rxjs.BehaviorSubject}
     *
     */

    _this.playerSubject = _this.observationCenter.playerSubject;
    /**
     *
     * @type {Rxjs.BehaviorSubject}
     *
     */

    _this.playerTimeSubject = _this.observationCenter.playerTimeSubject;
    /**
     *
     * @type {Rxjs.BehaviorSubject}
     *
     */

    _this.playerSubject = _this.observationCenter.playerSubject;
    /**
     *
     * @type {array}
     *
     */

    _this.currentVttItems = undefined;
    /**
     *
     * @type {object}
     * @desc The collection of bound listeners so we can add and remove easily
     *
     */

    _this.boundListeners = {};

    _this.bindListeners();

    return _this;
  }
  /**
   *
   * @desc Creates a map of bound event listeners for eainsy addition and removal
   *
   */


  html5_player_createClass(HTML5Player, [{
    key: "bindListeners",
    value: function bindListeners() {
      this.boundListeners[events.HTML5.MEDIA_LOAD_START] = this.onMediaLoadStart.bind(this);
      this.boundListeners[events.HTML5.CANPLAY] = this.onMediaCanPlay.bind(this);
      this.boundListeners[events.HTML5.MEDIA_START] = this.onMediaStart.bind(this);
      this.boundListeners[events.HTML5.MEDIA_LOADED_DATA] = this.onLoadedData.bind(this);
      this.boundListeners[events.HTML5.MEDIA_LOADED_META] = this.onLoadedMetadata.bind(this);
      this.boundListeners[events.HTML5.MEDIA_PAUSE] = this.onMediaPause.bind(this);
      this.boundListeners[events.HTML5.MEDIA_PLAYING] = this.onMediaPlaying.bind(this);
      this.boundListeners[events.HTML5.MEDIA_SEEKING] = this.onMediaSeeking.bind(this);
      this.boundListeners[events.HTML5.MEDIA_SEEKED] = this.onMediaSeeked.bind(this);
      this.boundListeners[events.HTML5.MEDIA_STALLED] = this.onMediaStalled.bind(this);
      this.boundListeners[events.HTML5.MEDIA_COMPLETE] = this.onMediaComplete.bind(this);
      this.boundListeners[events.HTML5.TIME_UPDATE] = this.onTimeUpdate.bind(this);
      this.boundListeners[events.HTML5.DURATION_CHANGE] = this.onDurationChange.bind(this);
      this.boundListeners[events.HTML5.VOLUME_CHANGE] = this.onVolumeChange.bind(this);
    }
    /**
     *
     * @desc creates the `<video/>` tag based on the provided PlayerTypeConfig configuration object.
     *
     */

  }, {
    key: "createPlayerElement",
    value: function createPlayerElement() {
      var videoEl = document.createElement('video');
      videoEl.controls = this.playerTypeConfig.controls;
      videoEl.autoplay = this.playerTypeConfig.autoPlay;
      videoEl.loop = this.playerTypeConfig.loop;
      videoEl.muted = this.playerTypeConfig.mute;

      if (!isNaN(this.playerTypeConfig.width)) {
        videoEl.setAttribute('width', this.playerTypeConfig.width);
      }

      if (!isNaN(this.playerTypeConfig.height)) {
        videoEl.setAttribute('height', this.playerTypeConfig.height);
      }

      if (this.playerTypeConfig.playsInline) {
        videoEl.setAttribute('playsinline', this.playerTypeConfig.playsInline);
      }

      if (this.playerTypeConfig.crossOrigin) {
        videoEl.setAttribute('crossorigin', this.playerTypeConfig.crossOrigin);
      }

      if (this.playerTypeConfig.preload) {
        videoEl.setAttribute('preload', this.playerTypeConfig.preload);
      }

      this.videoEl = videoEl;
      this.initListeners();
    }
    /**
     *
     * @desc Initialize event listeners
     *
     */

  }, {
    key: "initListeners",
    value: function initListeners() {
      _get2(html5_player_getPrototypeOf(HTML5Player.prototype), "initListeners", this).call(this);

      this.videoEl.addEventListener(events.HTML5.MEDIA_LOAD_START, this.boundListeners[events.HTML5.MEDIA_LOAD_START]);
      this.videoEl.addEventListener(events.HTML5.CANPLAY, this.boundListeners[events.HTML5.CANPLAY]);
      this.videoEl.addEventListener(events.HTML5.MEDIA_START, this.boundListeners[events.HTML5.MEDIA_START]);
      this.videoEl.addEventListener(events.HTML5.MEDIA_LOADED_DATA, this.boundListeners[events.HTML5.MEDIA_LOADED_DATA]);
      this.videoEl.addEventListener(events.HTML5.MEDIA_LOADED_META, this.boundListeners[events.HTML5.MEDIA_LOADED_META]);
      this.videoEl.addEventListener(events.HTML5.MEDIA_PAUSE, this.boundListeners[events.HTML5.MEDIA_PAUSE]);
      this.videoEl.addEventListener(events.HTML5.MEDIA_PLAYING, this.boundListeners[events.HTML5.MEDIA_PLAYING]);
      this.videoEl.addEventListener(events.HTML5.MEDIA_SEEKING, this.boundListeners[events.HTML5.MEDIA_SEEKING]);
      this.videoEl.addEventListener(events.HTML5.MEDIA_SEEKED, this.boundListeners[events.HTML5.MEDIA_SEEKED]);
      this.videoEl.addEventListener(events.HTML5.MEDIA_STALLED, this.boundListeners[events.HTML5.MEDIA_STALLED]);
      this.videoEl.addEventListener(events.HTML5.MEDIA_COMPLETE, this.boundListeners[events.HTML5.MEDIA_COMPLETE]);
      this.videoEl.addEventListener(events.HTML5.TIME_UPDATE, this.boundListeners[events.HTML5.TIME_UPDATE]);
      this.videoEl.addEventListener(events.HTML5.DURATION_CHANGE, this.boundListeners[events.HTML5.DURATION_CHANGE]);
      this.videoEl.addEventListener(events.HTML5.VOLUME_CHANGE, this.boundListeners[events.HTML5.VOLUME_CHANGE]);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      this.videoEl.removeEventListener(events.HTML5.MEDIA_LOAD_START, this.boundListeners[events.HTML5.MEDIA_LOAD_START]);
      this.videoEl.removeEventListener(events.HTML5.CANPLAY, this.boundListeners[events.HTML5.CANPLAY]);
      this.videoEl.removeEventListener(events.HTML5.MEDIA_START, this.boundListeners[events.HTML5.MEDIA_START]);
      this.videoEl.removeEventListener(events.HTML5.MEDIA_LOADED_DATA, this.boundListeners[events.HTML5.MEDIA_LOADED_DATA]);
      this.videoEl.removeEventListener(events.HTML5.MEDIA_LOADED_META, this.boundListeners[events.HTML5.MEDIA_LOADED_META]);
      this.videoEl.removeEventListener(events.HTML5.MEDIA_PAUSE, this.boundListeners[events.HTML5.MEDIA_PAUSE]);
      this.videoEl.removeEventListener(events.HTML5.MEDIA_PLAYING, this.boundListeners[events.HTML5.MEDIA_PLAYING]);
      this.videoEl.removeEventListener(events.HTML5.MEDIA_SEEKING, this.boundListeners[events.HTML5.MEDIA_SEEKING]);
      this.videoEl.removeEventListener(events.HTML5.MEDIA_SEEKED, this.boundListeners[events.HTML5.MEDIA_SEEKED]);
      this.videoEl.removeEventListener(events.HTML5.MEDIA_STALLED, this.boundListeners[events.HTML5.MEDIA_STALLED]);
      this.videoEl.removeEventListener(events.HTML5.MEDIA_COMPLETE, this.boundListeners[events.HTML5.MEDIA_COMPLETE]);
      this.videoEl.removeEventListener(events.HTML5.TIME_UPDATE, this.boundListeners[events.HTML5.TIME_UPDATE]);
      this.videoEl.removeEventListener(events.HTML5.DURATION_CHANGE, this.boundListeners[events.HTML5.DURATION_CHANGE]);
      this.videoEl.removeEventListener(events.HTML5.VOLUME_CHANGE, this.boundListeners[events.HTML5.VOLUME_CHANGE]);
    }
    /**
     *
     * @desc appends the `<video/>` tag to the parent element specified by `domTarget`
     *
     */

  }, {
    key: "attachPlayerElement",
    value: function attachPlayerElement() {
      this.parentEl.insertBefore(this.videoEl, this.parentEl.firstChild);
    }
    /**
     *
     * @desc create track nodes as children of the video node
     * @param {array} vttItems List of VttItems
     *
     */

  }, {
    key: "createTrackNodes",
    value: function createTrackNodes(vttItems) {
      var _this2 = this;

      var textTracksPromises = []; // Only crate new trackNodes

      if (this.currentVttItems === vttItems) {
        return;
      }

      this.currentVttItems = vttItems;
      vttItems.forEach(function (vttItem) {
        textTracksPromises.push(new Promise(function (resolve) {
          vttItem.id = "".concat(vttItem.label, " captions");
          var trackEl = document.createElement('track');
          trackEl.onload = resolve.bind(_this2, vttItem);
          trackEl.setAttribute('label', vttItem.label);
          trackEl.setAttribute('kind', vttItem.kind);
          trackEl.setAttribute('language', vttItem.srclang);
          trackEl.setAttribute('src', vttItem.src);
          trackEl.setAttribute('id', vttItem.id);
          trackEl.default = vttItem.default;

          _this2.videoEl.appendChild(trackEl);
        }));
      });
      Promise.all(textTracksPromises).then(function (savedTracks) {
        var textTracks = get_default()(_this2.videoEl, 'textTracks', []);

        var textTracksAvailable = false;

        if (textTracks.length) {
          var textTracksArr = [].slice.call(textTracks);
          textTracksArr.forEach(function (textTrack) {
            if (textTrack.mode !== 'disabled') {
              var trackIdx = savedTracks.findIndex(function (savedTrack) {
                return get_default()(savedTrack, 'id') === get_default()(textTrack, 'id');
              });
              textTrack.isVttFile = trackIdx !== -1;
              textTrack.mode = 'hidden';
              textTracksAvailable = true;
            }
          });

          if (textTracksAvailable) {
            _this2.playerSubject.next(new html5_media_message(events.HTML5.TEXT_TRACKS_AVAILABLE, null, textTracks));
          }
        }
      });
    }
    /**
     *
     * @desc Activate given text track (subtitles/captions)
     * @param {int} index (default: 0) Index of the track, in the order given by the textTracks property
     *
     */

  }, {
    key: "showClosedCaptions",
    value: function showClosedCaptions() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var textTrack = get_default()(this.videoEl, "textTracks.".concat(index));

      if (textTrack) {
        textTrack.mode = 'showing';
        this.playerSubject.next(new html5_media_message(events.HTML5.TEXT_TRACK_ENABLED, null, textTrack));
      }
    }
    /**
     *
     * @desc Hide all text tracks (subtitles/captions)
     *
     */

  }, {
    key: "hideClosedCaptions",
    value: function hideClosedCaptions() {
      var textTracks = get_default()(this.videoEl, 'textTracks', []);

      Array.from(textTracks).forEach(function (track) {
        track.mode = 'hidden';
      });
      this.playerSubject.next(new html5_media_message(events.HTML5.TEXT_TRACK_DISABLED, null, textTracks));
    }
    /**
     *
     * @param {string} src The playback URL
     * @abstract
     *
     */

  }, {
    key: "canPlay",
    value: function canPlay(src) {
      var regexp = new RegExp('(\.mp4|\.ogg|\.webm|\.mp3)', 'i');
      return regexp.test(src);
    }
    /**
     *
     * @desc Sets the `src` attribute of the current `<video/>` node
     * @param {MediaItem} mediaItem the MediaItem object to set for playback
     *
     */

  }, {
    key: "open",
    value: function open(mediaItem) {
      if (mediaItem.src) {
        this.currentMediaItem = mediaItem;
        this.videoEl.setAttribute('src', this.currentMediaItem.src);
        this.setPoster(this.currentMediaItem.poster);
      } else {
        throw new Error('MediaItem must have a "src" property.');
      }
    }
    /**
     *
     * @desc Play media when paused or stopped
     *
     */

  }, {
    key: "play",
    value: function play() {
      this.videoEl.play();
    }
    /**
     *
     * @desc Pause media playback
     *
     */

  }, {
    key: "pause",
    value: function pause() {
      this.videoEl.pause();
    }
    /**
     *
     * @desc Sets the currentTime to 0.
     *
     */

  }, {
    key: "replay",
    value: function replay() {
      this.videoEl.currentTime = 0;
      this.videoEl.play();
    }
    /**
     *
     * @description Set poster image for the HTML5 player
     * @param {string} imgUrl
     * @memberof HTML5Player
     *
     */

  }, {
    key: "setPoster",
    value: function setPoster(imgUrl) {
      if (imgUrl && imgUrl !== '') {
        this.videoEl.setAttribute('poster', imgUrl);
      }
    }
    /**
     *
     * @desc Seek to the specified time
     * @param {Number} time The time to seek to
     *
     */

  }, {
    key: "seek",
    value: function seek(time) {
      this.videoEl.currentTime = time;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var parentNode;

      if (this.videoEl) {
        this.removeListeners();
        parentNode = get_default()(this.videoEl, 'parentNode');
        parentNode.removeChild(this.videoEl);
      }

      _get2(html5_player_getPrototypeOf(HTML5Player.prototype), "destroy", this).call(this);
    }
  }, {
    key: "onMediaLoadStart",
    value: function onMediaLoadStart(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_LOAD_START, event));
    }
  }, {
    key: "onMediaCanPlay",
    value: function onMediaCanPlay(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.CANPLAY, event));
    }
  }, {
    key: "onMediaStart",
    value: function onMediaStart(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_START, event));
    }
  }, {
    key: "onLoadedData",
    value: function onLoadedData(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_LOADED_DATA, event));
    }
  }, {
    key: "onLoadedMetadata",
    value: function onLoadedMetadata(event, data) {
      this.createTrackNodes(this.currentMediaItem.vttItems);
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_LOADED_META, event));
    }
  }, {
    key: "onMediaPause",
    value: function onMediaPause(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_PAUSE, event));
    }
  }, {
    key: "onMediaPlaying",
    value: function onMediaPlaying(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_PLAYING, event));
    }
  }, {
    key: "onMediaSeeking",
    value: function onMediaSeeking(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_SEEKING, event));
    }
  }, {
    key: "onMediaSeeked",
    value: function onMediaSeeked(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_SEEKED, event));
    }
  }, {
    key: "onMediaStalled",
    value: function onMediaStalled(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_STALLED, event));
    }
  }, {
    key: "onMediaComplete",
    value: function onMediaComplete(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.MEDIA_COMPLETE, event));
    }
  }, {
    key: "onTimeUpdate",
    value: function onTimeUpdate(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.TIME_UPDATE, event));
    }
  }, {
    key: "onDurationChange",
    value: function onDurationChange(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.DURATION_CHANGE, event));
    }
  }, {
    key: "onVolumeChange",
    value: function onVolumeChange(event, data) {
      this.playerSubject.next(new html5_media_message(events.HTML5.VOLUME_CHANGE, event));
    }
  }, {
    key: "removeDefaultControls",
    value: function removeDefaultControls() {
      this.videoEl.controls = '';
    }
    /**
     *
     * @desc Returns the object type as a string
     * @abstract
     *
     */

  }, {
    key: "toString",
    value: function toString() {
      return 'HTML5Player';
    }
  }]);

  return HTML5Player;
}(base_player);

/* harmony default export */ var html5_player = (html5_player_HTML5Player);
// CONCATENATED MODULE: ./src/js/comm/message/hlsjs-media-event.js
function hlsjs_media_event_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hlsjs_media_event_typeof = function _typeof(obj) { return typeof obj; }; } else { hlsjs_media_event_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hlsjs_media_event_typeof(obj); }

function hlsjs_media_event_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function hlsjs_media_event_possibleConstructorReturn(self, call) { if (call && (hlsjs_media_event_typeof(call) === "object" || typeof call === "function")) { return call; } return hlsjs_media_event_assertThisInitialized(self); }

function hlsjs_media_event_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function hlsjs_media_event_getPrototypeOf(o) { hlsjs_media_event_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hlsjs_media_event_getPrototypeOf(o); }

function hlsjs_media_event_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hlsjs_media_event_setPrototypeOf(subClass, superClass); }

function hlsjs_media_event_setPrototypeOf(o, p) { hlsjs_media_event_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hlsjs_media_event_setPrototypeOf(o, p); }


/**
 *
 * @module HLSJSMediaEvent
 * @desc Message containing a type and event object
 * @class HLSJSMediaEvent
 *
 */

var HLSJSMediaEvent =
/*#__PURE__*/
function (_BaseMessage) {
  hlsjs_media_event_inherits(HLSJSMediaEvent, _BaseMessage);

  /**
   *
   * @param {string} type
   * @param {Event} event s
   * @constructor
   *
   */
  function HLSJSMediaEvent(type, mediaPlayer, data) {
    hlsjs_media_event_classCallCheck(this, HLSJSMediaEvent);

    return hlsjs_media_event_possibleConstructorReturn(this, hlsjs_media_event_getPrototypeOf(HLSJSMediaEvent).call(this, type, mediaPlayer, data));
  }

  return HLSJSMediaEvent;
}(base_message);

/* harmony default export */ var hlsjs_media_event = (HLSJSMediaEvent);
// CONCATENATED MODULE: ./src/js/util/helpers.js
var applyProperties = function applyProperties(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }
};
// CONCATENATED MODULE: ./src/js/config/hlsjs-player-config.js
function hlsjs_player_config_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/**
 *
 * @module HLSJSPlayerConfig
 * @desc The hls.js config object. Passed to the hls.js constructor. This config object is set on `MediaPlayerConfig.playerConfig.hlsjsPlayerConfig`
 * Reference: https://github.com/video-dev/hls.js/blob/master/docs/API.md#fine-tuning
 * @class HLSJSPlayerConfig
 *
 */

var hlsjs_player_config_HLSJSPlayerConfig =
/**
 *
 * @param {object} hlsConfig overrides for the hls.js config
 * @constructor
 *
 */
function HLSJSPlayerConfig(hlsConfig) {
  hlsjs_player_config_classCallCheck(this, HLSJSPlayerConfig);

  /**
   *
   * @type {boolean}
   *
   */
  this.autoStartLoad = true;
  /**
   *
   * @type {int}
   *
   */

  this.startPosition = -1;
  /**
   *
   * @type {boolean}
   *
   */

  this.capLevelToPlayerSize = false;
  /**
   *
   * @type {boolean}
   *
   */

  this.debug = false;
  /**
   *
   * @type {string}
   *
   */

  this.defaultAudioCodec = undefined;
  /**
   *
   * @type {int}
   *
   */

  this.initialLiveManifestSize = 1;
  /**
   *
   * @type {int}
   *
   */

  this.maxBufferLength = 30;
  /**
   *
   * @type {int}
   *
   */

  this.maxMaxBufferLength = 600;
  /**
   *
   * @type {int}
   *
   */

  this.maxBufferSize = 60 * 1000 * 1000;
  /**
   *
   * @type {number}
   *
   */

  this.maxBufferHole = 0.5;
  /**
   *
   * @type {number}
   *
   */

  this.lowBufferWatchdogPeriod = 0.5;
  /**
   *
   * @type {int}
   *
   */

  this.highBufferWatchdogPeriod = 3;
  /**
   *
   * @type {number}
   *
   */

  this.nudgeOffset = 0.1;
  /**
   *
   * @type {number}
   *
   */

  this.nudgeMaxRetry = 3;
  /**
   *
   * @type {number}
   *
   */

  this.maxFragLookUpTolerance = 0.2;
  /**
   *
   * @type {int}
   *
   */

  this.liveSyncDurationCount = 3;
  /**
   *
   * @type {int}
   *
   */

  this.liveMaxLatencyDurationCount = Infinity;
  /**
   *
   * @type {int}
   *
   */

  this.liveSyncDuration = undefined;
  /**
   *
   * @type {int}
   *
   */

  this.liveMaxLatencyDuration = undefined;
  /**
   *
   * @type {bool}
   *
   */

  this.liveDurationInfinity = false;
  /**
   *
   * @type {int}
   *
   */

  this.liveBackBufferLength = Infinity;
  /**
   *
   * @type {boolean}
   *
   */

  this.enableWorker = true;
  /**
   *
   * @type {boolean}
   *
   */

  this.enableSoftwareAES = true;
  /**
   *
   * @type {int}
   *
   */

  this.manifestLoadingTimeOut = 10000;
  /**
   *
   * @type {int}
   *
   */

  this.manifestLoadingMaxRetry = 1;
  /**
   *
   * @type {int}
   *
   */

  this.manifestLoadingRetryDelay = 500;
  /**
   *
   * @type {int}
   *
   */

  this.manifestLoadingMaxRetryTimeout = 64000;
  /**
   *
   * @type {int}
   *
   */

  this.startLevel = undefined;
  /**
   *
   * @type {int}
   *
   */

  this.levelLoadingTimeOut = 10000;
  /**
   *
   * @type {int}
   *
   */

  this.levelLoadingMaxRetry = 4;
  /**
   *
   * @type {int}
   *
   */

  this.levelLoadingRetryDelay = 500;
  /**
   *
   * @type {int}
   *
   */

  this.levelLoadingMaxRetryTimeout = 64000;
  /**
   *
   * @type {int}
   *
   */

  this.fragLoadingTimeOut = 20000;
  /**
   *
   * @type {int}
   *
   */

  this.fragLoadingMaxRetry = 6;
  /**
   *
   * @type {int}
   *
   */

  this.fragLoadingRetryDelay = 500;
  /**
   *
   * @type {int}
   *
   */

  this.fragLoadingMaxRetryTimeout = 64000;
  /**
   *
   * @type {boolean}
   *
   */

  this.startFragPrefetch = false;
  /**
   *
   * @type {number}
   *
   */

  this.appendErrorMaxRetry = 3;
  /**
   *
   * @type {function}
   *
   */
  // Something in hls.js requires loader to not exist at all, if it's not set

  if (hlsConfig && hlsConfig.hasOwnProperty('loader')) {
    this.loader = hlsConfig.loader;
  }
  /**
   *
   * @type {function}
   *
   */
  // Something in hls.js requires fLoader to not exist at all, if it's not set


  if (hlsConfig && hlsConfig.hasOwnProperty('fLoader')) {
    this.fLoader = hlsConfig.fLoader;
  }
  /**
   *
   * @type {function}
   *
   */
  // Something in hls.js requires pLoader to not exist at all, if it's not set


  if (hlsConfig && hlsConfig.hasOwnProperty('pLoader')) {
    this.pLoader = hlsConfig.pLoader;
  }
  /**
   *
   * @type {function}
   *
   */
  // Something in hls.js requires xhrSetup to not exist at all, if it's not set


  if (hlsConfig && hlsConfig.hasOwnProperty('xhrSetup')) {
    this.xhrSetup = hlsConfig.xhrSetup;
  }
  /**
   *
   * @type {function}
   *
   */
  // Something in hls.js requires fetchSetup to not exist at all, if it's not set


  if (hlsConfig && hlsConfig.hasOwnProperty('fetchSetup')) {
    this.fetchSetup = hlsConfig.fetchSetup;
  }
  /**
   *
   * @type {function}
   *
   */
  // Something in hls.js requires abrController to not exist at all, if it's not set


  if (hlsConfig && hlsConfig.hasOwnProperty('abrController')) {
    this.abrController = hlsConfig.abrController;
  }
  /**
   *
   * @type {function}
   *
   */
  // Something in hls.js requires timelineController to not exist at all, if it's not set


  if (hlsConfig && hlsConfig.hasOwnProperty('timelineController')) {
    this.timelineController = hlsConfig.timelineController;
  }
  /**
   *
   * @type {boolean}
   *
   */


  this.enableWebVTT = false;
  /**
   *
   * @type {boolean}
   *
   */

  this.enableCEA708Captions = true;
  /**
   *
   * @type {boolean}
   * @desc (default: `false`) If `true` will enable the default subtitle display. If using custom subtitle display, set to `false`
   *
   */

  this.subtitleDisplay = false;
  /**
   *
   * @type {string} Label for the text track generated for CEA-708 captions track 1. This is how it will appear in the browser's native menu for subtitles and captions.
   *
   */

  this.captionsTextTrack1Label = 'English';
  /**
   *
   * @type {boolean}
   *
   */

  this.stretchShortVideoTrack = false;
  /**
   *
   * @type {int}
   *
   */

  this.maxAudioFramesDrift = 1;
  /**
   *
   * @type {boolean}
   *
   */

  this.forceKeyFrameOnDiscontinuity = true;
  /**
   *
   * @type {number}
   *
   */

  this.abrEwmaFastLive = 5.0;
  /**
   *
   * @type {number}
   *
   */

  this.abrEwmaSlowLive = 9.0;
  /**
   *
   * @type {number}
   *
   */

  this.abrEwmaFastVoD = 4.0;
  /**
   *
   * @type {number}
   *
   */

  this.abrEwmaSlowVoD = 15.0;
  /**
   *
   * @type {int}
   *
   */

  this.abrEwmaDefaultEstimate = 500000;
  /**
   *
   * @type {number}
   *
   */

  this.abrBandWidthFactor = 0.95;
  /**
   *
   * @type {number}
   *
   */

  this.abrBandWidthUpFactor = 0.7;
  /**
   *
   * @type {int}
   *
   */

  this.minAutoBitrate = 0;
  applyProperties(this, hlsConfig);
};

/* harmony default export */ var hlsjs_player_config = (hlsjs_player_config_HLSJSPlayerConfig);
// CONCATENATED MODULE: ./src/js/player/hlsjs/hlsjs-player.js
function hlsjs_player_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { hlsjs_player_typeof = function _typeof(obj) { return typeof obj; }; } else { hlsjs_player_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return hlsjs_player_typeof(obj); }

function hlsjs_player_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function hlsjs_player_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function hlsjs_player_createClass(Constructor, protoProps, staticProps) { if (protoProps) hlsjs_player_defineProperties(Constructor.prototype, protoProps); if (staticProps) hlsjs_player_defineProperties(Constructor, staticProps); return Constructor; }

function hlsjs_player_possibleConstructorReturn(self, call) { if (call && (hlsjs_player_typeof(call) === "object" || typeof call === "function")) { return call; } return hlsjs_player_assertThisInitialized(self); }

function hlsjs_player_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function hlsjs_player_get2(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { hlsjs_player_get2 = Reflect.get; } else { hlsjs_player_get2 = function _get(target, property, receiver) { var base = hlsjs_player_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return hlsjs_player_get2(target, property, receiver || target); }

function hlsjs_player_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = hlsjs_player_getPrototypeOf(object); if (object === null) break; } return object; }

function hlsjs_player_getPrototypeOf(o) { hlsjs_player_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return hlsjs_player_getPrototypeOf(o); }

function hlsjs_player_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) hlsjs_player_setPrototypeOf(subClass, superClass); }

function hlsjs_player_setPrototypeOf(o, p) { hlsjs_player_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return hlsjs_player_setPrototypeOf(o, p); }






/**
 *
 * @module HLSJSPlayer
 * @desc Concrete HTML5 video player implementation
 * @class HLSJSPlayer
 *
 */

var hlsjs_player_HLSJSPlayer =
/*#__PURE__*/
function (_HTML5Player) {
  hlsjs_player_inherits(HLSJSPlayer, _HTML5Player);

  /**
   *
   * @constructor
   * @param {MediaPlayerConfig.MediaPlayerConfig} The MediaPlayerConfig object. Contains the PlayerTypeConfig object used to construct the `<video/>` node.
   * @param {MediaPlayer.ObservationCenter} The ObservationCenter object. Contains subjects to subscribe to for event streams.
   *
   */
  function HLSJSPlayer(mediaPlayerConfig, observationCenter) {
    var _this;

    hlsjs_player_classCallCheck(this, HLSJSPlayer);

    _this = hlsjs_player_possibleConstructorReturn(this, hlsjs_player_getPrototypeOf(HLSJSPlayer).call(this, mediaPlayerConfig, observationCenter));
    /**
     *
     * @type HLS
     *
     */

    _this.hls = undefined;
    /**
     *
     * @type {Rxjs.BehaviorSubject}
     *
     */

    _this.playerSubject = _this.observationCenter.playerSubject;

    var configData = get_default()(_this.playerTypeConfig, 'hlsPlayerConfig', {});
    /**
     *
     * @type {MediaPlayer.HLSPlayerConfig}
     *
     */


    _this.hlsPlayerConfig = new hlsjs_player_config(configData);

    _this.bindListeners();

    return _this;
  }
  /**
   *
   * @desc Creates a map of bound event listeners for easy addition and removal
   *
   */


  hlsjs_player_createClass(HLSJSPlayer, [{
    key: "bindListeners",
    value: function bindListeners() {
      hlsjs_player_get2(hlsjs_player_getPrototypeOf(HLSJSPlayer.prototype), "bindListeners", this).call(this);

      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MEDIA_ATTACHING] = this.onMediaAttaching.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MEDIA_ATTACHED] = this.onMediaAttached.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MEDIA_DETACHING] = this.onMediaDetaching.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MEDIA_DETACHED] = this.onMediaDetached.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_RESET] = this.onBufferReset.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_CREATED] = this.onBufferCreated.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_APPENDING] = this.onBufferAppending.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_APPENDED] = this.onBufferAppended.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_CODECS] = this.onBufferCodecs.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_EOS] = this.onBufferEos.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_FLUSHING] = this.onBufferFlushing.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_FLUSHED] = this.onBufferFlushed.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.ERROR] = this.onError.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MANIFEST_LOADING] = this.onManifestLoading.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MANIFEST_LOADED] = this.onManifestLoaded.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MANIFEST_PARSED] = this.onManifestParsed.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_SWITCHING] = this.onLevelSwitching.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_SWITCHED] = this.onLevelSwitched.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_LOADING] = this.onLevelLoading.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_LOADED] = this.onLevelLoaded.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_UPDATED] = this.onLevelUpdated.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_PTS_UPDATED] = this.onLevelPtsUpdated.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACKS_UPDATED] = this.onAudioTracksUpdated.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACK_SWITCHING] = this.onAudioTrackSwitching.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACK_SWITCHED] = this.onAudioTrackSwitched.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACK_LOADING] = this.onAudioTrackLoading.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACK_LOADED] = this.onAudioTrackLoaded.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_TRACKS_UPDATED] = this.onSubtitleTracksUpdated.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_TRACK_SWITCH] = this.onSubtitleTrackSwitch.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_TRACK_LOADING] = this.onSubtitleTrackLoading.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_TRACK_LOADED] = this.onSubtitleTrackLoaded.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_FRAG_PROCESSED] = this.onSubtitleFragProcessed.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.INIT_PTS_FOUND] = this.onInitPtsFound.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_LOADING] = this.onFragLoading.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_LOAD_PROGRESS] = this.onFragLoadProgress.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_LOAD_EMERGENCY_ABORTED] = this.onFragLoadEmergencyAborted.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_LOADED] = this.onFragLoaded.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_DECRYPTED] = this.onFragDecrypted.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSING_INIT_SEGMENT] = this.onFragParsingInitSegment.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSING_USERDATA] = this.onFragParsingUserdata.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSING_METADATA] = this.onFragParsingMetadata.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSING_DATA] = this.onFragParsingData.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSED] = this.onFragParsed.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_BUFFERED] = this.onFragBuffered.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_CHANGED] = this.onFragChanged.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FPS_DROP] = this.onFpsDrop.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FPS_DROP_LEVEL_CAPPING] = this.onFpsDropLevelCapping.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.DESTROYING] = this.onDestroying.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.KEY_LOADING] = this.onKeyLoading.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.KEY_LOADED] = this.onKeyLoaded.bind(this);
      this.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.STREAM_STATE_TRANSITION] = this.onStreamStateTransition.bind(this);
    }
    /**
     *
     * @desc creates the `<video/>` tag based on the provided PlayerTypeConfig configuration object.
     *
     */

  }, {
    key: "createPlayerElement",
    value: function createPlayerElement() {
      this.playerEvents = this.getPlayerEvents(this.playerTypeConfig.playerType);

      hlsjs_player_get2(hlsjs_player_getPrototypeOf(HLSJSPlayer.prototype), "createPlayerElement", this).call(this);
    }
    /**
     *
     * @desc appends the `<video/>` tag to the parent element specified by `domTarget`
     *
     */

  }, {
    key: "attachPlayerElement",
    value: function attachPlayerElement() {
      this.parentEl.insertBefore(this.videoEl, this.parentEl.firstChild);
    }
    /**
     *
     * @param {string} src The playback URL
     * @abstract
     *
     */

  }, {
    key: "canPlay",
    value: function canPlay(src) {
      var regexp = new RegExp('(\.m3u8|format=m3u8)', 'i');
      return regexp.test(src);
    }
    /**
     *
     * @desc Sets the `src` attribute of the current `<video/>` node
     * @param {MediaItem} mediaItem the MediaItem object to set for playback
     *
     */

  }, {
    key: "open",
    value: function open(mediaItem) {
      if (mediaItem.src) {
        if (this.hls) {
          this.hls.detachMedia();
          this.hls.destroy();
          this.removeHlsListeners();
        }

        this.currentMediaItem = mediaItem;
        this.hls = new external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a(this.hlsPlayerConfig);
        this.hls.subtitleDisplay = this.hlsPlayerConfig.subtitleDisplay;
        this.initHlsListeners();
        this.setPoster(mediaItem.poster);
        this.hls.loadSource(mediaItem.src);
        this.hls.attachMedia(this.videoEl);
      }
    }
    /**
     *
     * @desc Seeks to the "live point" of the feed. Live point of the feed is the duration less some amount of loaded
     * fragment duration. Currently that is 3 * fragmentDuration. This info its saved in the player state as seekableRange.end
     * @param {number} time The time in seconds to jump to
     *
     */

  }, {
    key: "jumpToLive",
    value: function jumpToLive() {
      this.videoEl.currentTime = this.timeStateModel.seekableRange.end;
    }
    /**
     *
     * @desc Clean up this object and hls.js
     *
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this.hls) {
        this.removeHlsListeners();
        this.hls.destroy();
      }

      hlsjs_player_get2(hlsjs_player_getPrototypeOf(HLSJSPlayer.prototype), "destroy", this).call(this);
    }
    /**
     *
     * @desc Initialize the HLS listeners
     *
     */

  }, {
    key: "initHlsListeners",
    value: function initHlsListeners() {
      var _this2 = this;

      if (this.hls) {
        Object.keys(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events).forEach(function (eventType) {
          _this2.hls.on(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events[eventType], _this2.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events[eventType]]);
        });
      }
    }
    /**
     *
     * @desc Removes event listeners
     *
     */

  }, {
    key: "removeListeners",
    value: function removeListeners() {
      hlsjs_player_get2(hlsjs_player_getPrototypeOf(HLSJSPlayer.prototype), "removeListeners", this).call(this);

      this.removeHlsListeners();
    }
  }, {
    key: "removeHlsListeners",
    value: function removeHlsListeners() {
      var _this3 = this;

      Object.keys(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events).forEach(function (eventType) {
        _this3.hls.off(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events[eventType], _this3.boundListeners[external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events[eventType]]);
      });
    }
    /**
     *
     * @desc Handles the HLS.Events.ERROR
     * @param {Event} event
     * @param {object} data { type : error type, details : error details, fatal : is error fatal or not, other error specific data }
     *
     */

  }, {
    key: "onError",
    value: function onError(event, data) {
      var errorType = data.type;
      var errorDetails = data.details;
      var errorFatal = data.fatal;
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.ERROR, this, data));

      switch (data.type) {
        case external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.ErrorTypes.NETWORK_ERROR:
          {
            this.hls.startLoad();
            break;
          }

        case external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.ErrorTypes.MEDIA_ERROR:
          {
            this.hls.recoverMediaError();
            break;
          }
      }
    }
  }, {
    key: "onMediaAttaching",
    value: function onMediaAttaching(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MEDIA_ATTACHING, this, data));
    }
  }, {
    key: "onMediaAttached",
    value: function onMediaAttached(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MEDIA_ATTACHED, this, data));
    }
  }, {
    key: "onMediaDetaching",
    value: function onMediaDetaching(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MEDIA_DETACHING, this, data));
    }
  }, {
    key: "onMediaDetached",
    value: function onMediaDetached(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MEDIA_DETACHED, this, data));
    }
  }, {
    key: "onBufferReset",
    value: function onBufferReset(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_RESET, this, data));
    }
  }, {
    key: "onBufferCreated",
    value: function onBufferCreated(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_CREATED, this, data));
    }
  }, {
    key: "onBufferAppending",
    value: function onBufferAppending(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_APPENDING, this, data));
    }
  }, {
    key: "onBufferAppended",
    value: function onBufferAppended(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_APPENDED, this, data));
    }
  }, {
    key: "onBufferCodecs",
    value: function onBufferCodecs(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_CODECS, this, data));
    }
  }, {
    key: "onBufferEos",
    value: function onBufferEos(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_EOS, this, data));
    }
  }, {
    key: "onBufferFlushing",
    value: function onBufferFlushing(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_FLUSHING, this, data));
    }
  }, {
    key: "onBufferFlushed",
    value: function onBufferFlushed(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.BUFFER_FLUSHED, this, data));
    }
  }, {
    key: "onManifestLoading",
    value: function onManifestLoading(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MANIFEST_LOADING, this, data));
    }
  }, {
    key: "onManifestLoaded",
    value: function onManifestLoaded(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MANIFEST_LOADED, this, data));
    }
  }, {
    key: "onManifestParsed",
    value: function onManifestParsed(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.MANIFEST_PARSED, this, data));
    }
  }, {
    key: "onLevelSwitching",
    value: function onLevelSwitching(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_SWITCHING, this, data));
    }
  }, {
    key: "onLevelSwitched",
    value: function onLevelSwitched(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_SWITCHED, this, data));
    }
  }, {
    key: "onLevelLoading",
    value: function onLevelLoading(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_LOADING, this, data));
    }
  }, {
    key: "onLevelLoaded",
    value: function onLevelLoaded(event, data) {
      this.fragmentDuration = data.details.targetduration;
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_LOADED, this, data));
    }
  }, {
    key: "onLevelUpdated",
    value: function onLevelUpdated(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_UPDATED, this, data));
    }
  }, {
    key: "onLevelPtsUpdated",
    value: function onLevelPtsUpdated(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.LEVEL_PTS_UPDATED, this, data));
    }
  }, {
    key: "onAudioTracksUpdated",
    value: function onAudioTracksUpdated(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACKS_UPDATED, this, data));
    }
  }, {
    key: "onAudioTrackSwitching",
    value: function onAudioTrackSwitching(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACK_SWITCHING, this, data));
    }
  }, {
    key: "onAudioTrackSwitched",
    value: function onAudioTrackSwitched(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACK_SWITCHED, this, data));
    }
  }, {
    key: "onAudioTrackLoading",
    value: function onAudioTrackLoading(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACK_LOADING, this, data));
    }
  }, {
    key: "onAudioTrackLoaded",
    value: function onAudioTrackLoaded(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.AUDIO_TRACK_LOADED, this, data));
    }
  }, {
    key: "onSubtitleTracksUpdated",
    value: function onSubtitleTracksUpdated(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_TRACKS_UPDATED, this, data));
    }
  }, {
    key: "onSubtitleTrackSwitch",
    value: function onSubtitleTrackSwitch(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_TRACK_SWITCH, this, data));
    }
  }, {
    key: "onSubtitleTrackLoading",
    value: function onSubtitleTrackLoading(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_TRACK_LOADING, this, data));
    }
  }, {
    key: "onSubtitleTrackLoaded",
    value: function onSubtitleTrackLoaded(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_TRACK_LOADED, this, data));
    }
  }, {
    key: "onSubtitleFragProcessed",
    value: function onSubtitleFragProcessed(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.SUBTITLE_FRAG_PROCESSED, this, data));
    }
  }, {
    key: "onInitPtsFound",
    value: function onInitPtsFound(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.INIT_PTS_FOUND, this, data));
    }
  }, {
    key: "onFragLoading",
    value: function onFragLoading(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_LOADING, this, data));
    }
  }, {
    key: "onFragLoadProgress",
    value: function onFragLoadProgress(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_LOAD_PROGRESS, this, data));
    }
  }, {
    key: "onFragLoadEmergencyAborted",
    value: function onFragLoadEmergencyAborted(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_LOAD_EMERGENCY_ABORTED, this, data));
    }
  }, {
    key: "onFragLoaded",
    value: function onFragLoaded(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_LOADED, this, data));
    }
  }, {
    key: "onFragDecrypted",
    value: function onFragDecrypted(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_DECRYPTED, this, data));
    }
  }, {
    key: "onFragParsingInitSegment",
    value: function onFragParsingInitSegment(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSING_INIT_SEGMENT, this, data));
    }
  }, {
    key: "onFragParsingUserdata",
    value: function onFragParsingUserdata(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSING_USERDATA, this, data));
    }
  }, {
    key: "onFragParsingMetadata",
    value: function onFragParsingMetadata(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSING_METADATA, this, data));
    }
  }, {
    key: "onFragParsingData",
    value: function onFragParsingData(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSING_DATA, this, data));
    }
  }, {
    key: "onFragParsed",
    value: function onFragParsed(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_PARSED, this, data));
    }
  }, {
    key: "onFragBuffered",
    value: function onFragBuffered(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_BUFFERED, this, data));
    }
  }, {
    key: "onFragChanged",
    value: function onFragChanged(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FRAG_CHANGED, this, data));
    }
  }, {
    key: "onFpsDrop",
    value: function onFpsDrop(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FPS_DROP, this, data));
    }
  }, {
    key: "onFpsDropLevelCapping",
    value: function onFpsDropLevelCapping(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.FPS_DROP_LEVEL_CAPPING, this, data));
    }
  }, {
    key: "onDestroying",
    value: function onDestroying(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.DESTROYING, this, data));
    }
  }, {
    key: "onKeyLoaded",
    value: function onKeyLoaded(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.KEY_LOADED, this, data));
    }
  }, {
    key: "onKeyLoading",
    value: function onKeyLoading(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.KEY_LOADING, this, data));
    }
  }, {
    key: "onStreamStateTransition",
    value: function onStreamStateTransition(event, data) {
      this.playerSubject.next(new hlsjs_media_event(external_commonjs_hls_js_commonjs2_hls_js_amd_hls_js_root_Hls_default.a.Events.STREAM_STATE_TRANSITION, this, data));
    }
    /**
     *
     * @desc Returns the object type as a string
     * @abstract
     *
     */

  }, {
    key: "toString",
    value: function toString() {
      return 'HLSJSPlayer';
    }
  }]);

  return HLSJSPlayer;
}(html5_player);

/* harmony default export */ var hlsjs_player = (hlsjs_player_HLSJSPlayer);
// CONCATENATED MODULE: ./src/js/player/player-factory.js
function player_factory_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function player_factory_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function player_factory_createClass(Constructor, protoProps, staticProps) { if (protoProps) player_factory_defineProperties(Constructor.prototype, protoProps); if (staticProps) player_factory_defineProperties(Constructor, staticProps); return Constructor; }






/**
 *
 * @module PlayerFactory
 * @desc Player object creation factory. Creates a concrete player
 *       based on media url and an optional playerType override.
 * @class PlayerFactory
 *
 */

var playerTypes = {
  HTML5: html5_player,
  HLSJS: hlsjs_player
};

var player_factory_PlayerFactory =
/*#__PURE__*/
function () {
  function PlayerFactory() {
    player_factory_classCallCheck(this, PlayerFactory);
  }

  player_factory_createClass(PlayerFactory, null, [{
    key: "create",

    /**
     *
     * @static
     * @desc Creates a concrete implementation of AbstractPlayer based on the provided
     * MediaPlayerConfig object. Currently only creates the HTML5 player.
     * @param {MediaPlayerConfig} config The media player's config to use to create a concrete player.
     * @param {ObservationCenter} observationCenter The media player's config to use to create a concrete player.
     * @returns AbstractPlayer the new Player object
     *
     */
    value: function create(config, observationCenter) {
      var playerToCreate = PlayerFactory.getPlayerToCreate(config.playerTypeConfig);
      return new playerToCreate(config, observationCenter);
    }
    /**
     *
     * @desc Returns the player object to create, based on the type passed. Will return undefined if
     * the payer object doesn't exist.
     * @param {string} playerType
     * @returns {string}
     *
     */

  }, {
    key: "getPlayerObjectByType",
    value: function getPlayerObjectByType(playerType) {
      return playerTypes[playerType];
    }
  }, {
    key: "getPlayerTypeFromSource",
    value: function getPlayerTypeFromSource(src, deviceInfo) {
      var webRegExp = /(\.mp4|\.mp3|\.ogg|\.webm)/i;
      var hlsRegExp = /(\.m3u8|format=m3u8)/i;
      var isWeb = webRegExp.test(src);
      var isHls = hlsRegExp.test(src);
      var forceHTML5 = deviceInfo.is.ios; // Force HTML5 player for ios, but not android

      var playerType = isHls && !forceHTML5 && !isWeb ? player_type.HLSJS : player_type.HTML5;
      return playerType;
    }
    /**
     *
     * @desc Gets the type of player to create based on the playerTypeConfig.playerType and src URL.
     * @param {MediaPlayer.PlayerTypeConfig} playerTypeConfig
     * @returns {Object} The object to create for the new player
     *
     */

  }, {
    key: "getPlayerToCreate",
    value: function getPlayerToCreate(playerTypeConfig) {
      var mediaItem = get_default()(playerTypeConfig, 'mediaItem');

      var deviceInfo = get_default()(playerTypeConfig, 'deviceInfo');

      var playerType = PlayerFactory.getPlayerTypeFromSource(mediaItem.src, deviceInfo);

      set_default()(playerTypeConfig, 'playerType', playerType);

      return PlayerFactory.getPlayerObjectByType(playerType);
    }
  }]);

  return PlayerFactory;
}();

/* harmony default export */ var player_factory = (player_factory_PlayerFactory);
// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/assign.js
var lodash_assign = __webpack_require__(30);
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// CONCATENATED MODULE: ./src/js/model/vtt-item.js
function vtt_item_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/**
 *
 * @class VttItem
 * @desc Represents a VTT subtitle track
 * @module VttItem
 *
 */

var vtt_item_VttItem =
/**
 *
 * @param {object} config Initial config object
 * @constructor
 *
 */
function VttItem(config) {
  vtt_item_classCallCheck(this, VttItem);

  /**
   *
   * @type {string}
   * @desc is given a value indicating which language that subtitle set is for — for example
   * English or Deutsch — these labels will appear in the user interface to allow the user
   * to easily select which subtitle language they want to see
   * @default "English"
   *
   */
  this.label = get_default()(config, 'label', 'English');
  /**
   *
   * @type {string}
   * @desc is given a value of subtitles, indicating the type of content the files contain
   * @default "subtitles"
   *
   */

  this.kind = get_default()(config, 'kind', 'subtitles');
  /**
   *
   * @type {string}
   * @desc indicates what language each subtitle files' contents are in.
   *
   */

  this.srclang = get_default()(config, 'srclang');
  /**
   *
   * @type {string}
   * @desc is assigned a valid URL pointing to the relevant WebVTT subtitle file in each case.
   *
   */

  this.src = get_default()(config, 'src');
  /**
   *
   * @type {boolean}
   * @desc indicates to the browser that this is the default subtitle file definition to use
   * when subtitles have been turned on and the user has not made a specific selection.
   * @default false
   *
   */

  this.default = get_default()(config, 'default', false);
};

/* harmony default export */ var vtt_item = (vtt_item_VttItem);
// CONCATENATED MODULE: ./src/js/model/media-item.js
function media_item_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function media_item_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function media_item_createClass(Constructor, protoProps, staticProps) { if (protoProps) media_item_defineProperties(Constructor.prototype, protoProps); if (staticProps) media_item_defineProperties(Constructor, staticProps); return Constructor; }



/**
 *
 * @class MediaItem
 * @desc Represents a media item to playback
 * @module MediaItem
 *
 */

var media_item_MediaItem =
/*#__PURE__*/
function () {
  function MediaItem(config) {
    media_item_classCallCheck(this, MediaItem);

    /**
     *
     * @type {string}
     * @desc address of the media resource
     *
     */
    this.src = get_default()(config, 'src');
    /**
     *
     * @type {string}
     * @desc The MIME-type of the resource, optionally with a codecs parameter. Examples:
     * mp4: "video/mp4"
     * m3u8: "application/x-mpegURL"
     *
     */

    this.type = get_default()(config, 'type');
    /**
     *
     * @type {array} List of VttItems
     * @desc VttItems to apply to the video tag for subtitles
     *
     */

    this.vttItems = this.getVttItems(get_default()(config, 'vttItems', []));
    /**
     *
     * @type {string}
     * @desc The url pointer to the poster image to use
     *
     */

    this.poster = get_default()(config, 'poster');
    /**
     *
     * @type {object}
     * @desc Media item metadata
     *
     */

    this.metaData = get_default()(config, 'metaData');
  }
  /**
   *
   * @desc builds a list of VttItems
   * @param {Array} vttList list of VTT config objects
   *
   */


  media_item_createClass(MediaItem, [{
    key: "getVttItems",
    value: function getVttItems(vttList) {
      var vttItems = [];
      vttList.forEach(function (item) {
        vttItems.push(new vtt_item(item));
      });
      return vttItems;
    }
  }]);

  return MediaItem;
}();

/* harmony default export */ var media_item = (media_item_MediaItem);
// CONCATENATED MODULE: ./src/js/config/player-type-config.js
function player_type_config_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function player_type_config_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function player_type_config_createClass(Constructor, protoProps, staticProps) { if (protoProps) player_type_config_defineProperties(Constructor.prototype, protoProps); if (staticProps) player_type_config_defineProperties(Constructor, staticProps); return Constructor; }





/**
 *
 * @module PlayerTypeConfig
 * @class PlayerTypeConfig
 * @desc Base PlayerTypeConfig. The Player type configuration object is passed to each player
 * and is used to determine the type of player to create.
 *
 */

var player_type_config_PlayerTypeConfig =
/*#__PURE__*/
function () {
  /**
   *
   * @param {JSON} data The JSON object used to create the PlayerTypeConfig
   */
  function PlayerTypeConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    player_type_config_classCallCheck(this, PlayerTypeConfig);

    /**
     *
     * @type {Object}
     * @desc The default configuration for the player.
     *
     */
    var defaultPlayerConfig = {
      domTarget: 'media-player',
      playerType: player_type.HTML5,
      controls: true,
      autoplay: true,
      playsinline: true,
      crossorigin: 'anonymous',
      width: undefined,
      height: undefined,
      loop: false,
      mediaItem: {
        src: undefined,
        type: undefined,
        poster: undefined
      },
      mute: false,
      preload: 'metadata',
      deviceInfo: {
        userAgent: undefined,
        is: {
          ios: undefined,
          blackberry: undefined,
          android: undefined,
          windowsphone: undefined,
          windows: undefined,
          linux: undefined,
          macintosh: undefined,
          webkit: undefined,
          gecko: undefined,
          trident: undefined,
          chrome: undefined,
          firefox: undefined,
          opera: undefined,
          operamini: undefined,
          msie: undefined,
          silk: undefined,
          safari: undefined,
          tablet: undefined,
          phone: undefined,
          desktop: undefined
        },
        platform: undefined,
        platformVersion: undefined,
        browser: undefined,
        browserVersion: undefined,
        formFactor: undefined
      }
    };
    /**
     *
     * @type {PlayerTypeConfig} Object player type config. This config will specify player specific configuration.
     * e.g. For bam-video-players, we'll need to pass on the SDK config. This is where that
     * config would be attached.
     *
     */

    this.config = assign_default()(defaultPlayerConfig, get_default()(config, 'playerTypeConfig', {}));
    /**
     *
     * @type {MediaItem}
     * @desc The initial MediaItem. A MediaItem represents media for playback as well as associated
     * objects such as vtt for subtitles.
     *
     */

    this._mediaItem = new media_item(get_default()(this.config, 'mediaItem'));
    /**
     *
     * @type {PlayerType}
     * @desc The type of player to create. Currently this is not used. We only have 1 player "HTML5".
     * The thought behind this property is to provide a way for the consumer to specify a player to create.
     *
     */

    this.playerType = get_default()(this.config, 'playerType', player_type.HTML5);
    /**
     *
     * @type {String} the id of the parent element for the player
     * @desc The id of the target parent element for the player. The generated `<video/>`
     * element will be appended to this element.
     *
     */

    this.domTarget = get_default()(this.config, 'domTarget', 'media-player');
    /**
     *
     * @type {Boolean}
     * @desc Specifies whether or not to display video controls (such as a play button, pause
     * button, volume control etc).
     *
     */

    this.controls = get_default()(this.config, 'controls', true);
    /**
     *
     * @type {Boolean}
     * @desc Instructs the video to start playing as soon as it can do so without stopping.
     * This results in the video starting automatically when the user loads the page. This
     * attribute is a boolean attribute. Therefore, the mere presence of this attribute equates
     * to a true value.
     *
     */

    this.autoPlay = get_default()(this.config, 'autoplay', true);
    /**
     *
     * @type {Boolean}
     * @desc Indicates the player that the video autoplay happened after a user initiated action.
     * For example, the user clicked a poster image and, after that, the video player was created.
     * In that case, playback should happen with sound, so the player is configured to be unmuted.
     *
     */

    this.clickToPlay = get_default()(this.config, 'clickToPlay', false);
    /**
     *
     * @type {Boolean}
     *
     */

    this.playsInline = get_default()(this.config, 'playsinline', true);
    /**
     *
     * @type {Boolean}
     * @desc This attribute is a CORS settings attribute. CORS stands
     * for Cross-Origin Resource Sharing. The purpose of the crossorigin attribute is to allow
     * you to configure the CORS requests for the element's fetched data. The values for the
     * crossorigin attribute are enumerated.
     *
     * Acceptable values:
     *
     * "anonymous": Cross-origin CORS requests for the element will not have the credentials
     * flag set. In other words, there will be no exchange of user credentials via cookies,
     * client-side SSL certificates or HTTP authentication.
     *
     * "use-credentials": Cross-origin CORS requests for the element will have the credentials
     * flag set.
     *
     * If this attribute is not specified, CORS is not used at all.
     *
     * An invalid keyword and an empty string will be handled as the anonymous value.
     *
     */

    this.crossOrigin = get_default()(this.config, 'crossorigin', 'anonymous');
    /**
     *
     * @type {Number}
     *
     */

    this.width = get_default()(this.config, 'width');
    /**
     *
     * @type {Number}
     *
     */

    this.height = get_default()(this.config, 'height');
    /**
     *
     * @type {Boolean}
     * @desc Specifies whether to keep re-playing the video once it has finished (i.e. it will
     * keep playing again and again until it is stopped).
     *
     */

    this.loop = get_default()(this.config, 'loop', false);
    /**
     *
     * @type {Boolean}
     * @desc Controls the default state of the video's audio output. If present, this attribute
     * results in the audio output being muted (i.e. there is no sound) upon loading. This
     * attribute will override the users' preferences. The user can then choose to turn on the
     * sound if he/she so wishes.
     *
     */

    this.mute = get_default()(this.config, 'mute', false);
    /**
     *
     * @type {Boolean}
     * @desc Specifies whether the video should be preloaded or not, and if so, how
     * it should be preloaded. Preloading allows the video to be loaded before it needs to be
     * used (eg, before the user clicks the "play" button). The preload attribute allows the
     * author to provide a hint to the browser/user agent about what the author thinks will
     * lead to the best user experience. This attribute may be ignored in some instances. For
     * example, if the user has disabled preloading or if there are network connectivity issues.
     *
     * Possible values: "none", "metadata", and "auto"
     *
     * Note: that the autoplay attribute can override the preload attribute (since if the
     * media plays, it naturally has to buffer first, regardless of the hint given by the
     * preload attribute). Despite this, you can still provide both attributes.
     *
     */

    this.preload = get_default()(this.config, 'preload', 'metadata');
    /**
     *
     * @type {object}
     * @desc Device specific infomation to aid in player type creation logic. Info includes browser, browser version, os, form-factor.
     * Example deviceInfo object:
     * ```js
     *  "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_9_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/35.0.1916.153 Safari/537.36",
     *  "is": {
     *      "ios": false,
     *      "blackberry": false,
     *      "android": false,
     *      "windowsphone": false,
     *      "windows": false,
     *      "linux": false,
     *      "macintosh": true,
     *      "webkit": true,
     *      "gecko": false,
     *      "trident": false,
     *      "chrome": true,
     *      "firefox": false,
     *      "opera": false,
     *      "operamini": false,
     *      "msie": false,
     *      "silk": false,
     *      "safari": false,
     *      "tablet": false,
     *      "phone": false,
     *      "desktop": true
     *  },
     *  "platform": "macintosh",
     *  "platformVersion": "10.9.2",
     *  "browser": "chrome",
     *  "browserVersion": "35.0.1916",
     *  "formFactor": "desktop"
     * ```
     *
     */

    this.deviceInfo = get_default()(this.config, 'deviceInfo', defaultPlayerConfig.deviceInfo);
    /**
     *
     * @type {MediaPlayer.HLSJSPlayerConfig}
     * @desc Configuration object to be passed to the hls.js constructor
     * Reference: https://github.com/video-dev/hls.js/blob/master/docs/API.md#fine-tuning
     *
     */

    this.hlsjsPlayerConfig = undefined;
  }
  /**
   *
   * @desc mediaItem getting
   * @returns {MediaItem} mediaItem
   *
   */


  player_type_config_createClass(PlayerTypeConfig, [{
    key: "mediaItem",
    get: function get() {
      if (!this._mediaItem instanceof media_item) {
        this._mediaItem = new media_item(this._mediaItem);
      }

      return this._mediaItem;
    }
    /**
     *
     * @desc mediaItem setter
     * @prop {MediaItem|Object} mediaItem The mediaItem to set. Can be an object or a MediaItem
     *
     */
    ,
    set: function set(value) {
      if (!value instanceof media_item) {
        this._mediaItem = new media_item(value);
      } else {
        this._mediaItem = new media_item(value);
      }
    }
  }]);

  return PlayerTypeConfig;
}();

/* harmony default export */ var player_type_config = (player_type_config_PlayerTypeConfig);
// CONCATENATED MODULE: ./src/js/util/media-config-util.js
function media_config_util_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function media_config_util_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function media_config_util_createClass(Constructor, protoProps, staticProps) { if (protoProps) media_config_util_defineProperties(Constructor.prototype, protoProps); if (staticProps) media_config_util_defineProperties(Constructor, staticProps); return Constructor; }



/**
 *
 * @module MediaConfigUtils
 * @desc A utility to help with creating the MediaPlayerConfig and PlayerTypeConfig objects
 * @class MediaConfigUtils
 *
 */

var media_config_util_MediaConfigUtils =
/*#__PURE__*/
function () {
  function MediaConfigUtils() {
    media_config_util_classCallCheck(this, MediaConfigUtils);
  }

  media_config_util_createClass(MediaConfigUtils, null, [{
    key: "create",

    /**
     *
     * @param {Object} config Object a JSON object of top-level configuration. This can include
     * a property `playerTypeConfig` that will create a PlayerTypeConfig object.
     * @static
     *
     */
    value: function create(config) {
      return MediaConfigUtils.createMediaPlayerConfig(config);
    }
    /**
     *
     * @desc Creates a MediaPlayerConfig object
     * @param {JSON} config The JSON data to create a MediaPlayerConfig object with
     * @static
     *
     */

  }, {
    key: "createMediaPlayerConfig",
    value: function createMediaPlayerConfig(config) {
      var mediaPlayerConfig = new media_player_config(config);
      return mediaPlayerConfig;
    }
    /**
     *
     * @desc Creates a PlayerTypeConfig object. Pass a JSON object with a`playerTypeConfig`
     * property to provide the data to the PlayerTypeConfig object.
     * @param {JSON} config The data to create a PlayerTypeConfig object with
     * @static
     *
     */

  }, {
    key: "createPlayerTypeConfig",
    value: function createPlayerTypeConfig(config) {
      return new player_type_config(config);
    }
  }]);

  return MediaConfigUtils;
}();

/* harmony default export */ var media_config_util = (media_config_util_MediaConfigUtils);
// CONCATENATED MODULE: ./src/js/config/plugin-config.js
function plugin_config_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 *
 * @module PluginConfig
 * @desc
 * @class PluginConfig
 *
 */

var plugin_config_PluginConfig =
/**
 *
 * @constructor
 * @param {Object} config
 *
 */
function PluginConfig(config) {
  plugin_config_classCallCheck(this, PluginConfig);

  /**
   *
   * @type {Object}
   *
   */
  this.config = config; // Apply all the config properties to this object

  applyProperties(this, this.config); // Now, let's set some defaults

  /**
   *
   * @type {string}
   *
   */

  this.name = get_default()(config, 'name');
  /**
   *
   * @type {string}
   * @todo set to PluginType enum
   *
   */

  this.type = get_default()(config, 'type');
  /**
   *
   * @type {*}
   *
   */

  this.pluginReference = get_default()(config, 'pluginReference');

  if (!this.pluginReference) {
    throw new Error('PluginConfig.pluginReference is required!');
  }
};

/* harmony default export */ var plugin_config = (plugin_config_PluginConfig);
// CONCATENATED MODULE: ./src/js/config/media-player-config.js
function media_player_config_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function media_player_config_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function media_player_config_createClass(Constructor, protoProps, staticProps) { if (protoProps) media_player_config_defineProperties(Constructor.prototype, protoProps); if (staticProps) media_player_config_defineProperties(Constructor, staticProps); return Constructor; }





/**
 *
 * @module MediaPlayerConfig
 * @desc The MediaPlayerConfig object contains the top-level configuration data and defaults necessary to create a player.
 * @class MediaPlayerConfig
 *
 */

var media_player_config_MediaPlayerConfig =
/*#__PURE__*/
function () {
  /**
   *
   * @param {object} data Object used to create the MediaPlayerConfig object
   * @constructor
   *
   */
  function MediaPlayerConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    media_player_config_classCallCheck(this, MediaPlayerConfig);

    /**
     *
     * @type {object}
     * @desc the config passed in on creation
     *
     */
    this.config = config; // Apply all the config properties to this object

    applyProperties(this, this.config); // Now, let's set some defaults

    /**
     *
     * @type {PlayerTypeConfig}
     * @desc the PlayerTypeConfig object created from data.playerTypeConfig in the data param
     *
     */

    this.playerTypeConfig = media_config_util.createPlayerTypeConfig(this.config);
    /**
     *
     * @type {Array}
     * @desc Array of PluginConfig objects
     *
     */

    this.pluginConfigs = this.getPluginConfigs(get_default()(this.config, 'pluginConfigs', []));
  }
  /**
   *
   * @desc Creates a list of PluginConfig objects for the defined plugins configs
   * @param {Array} pluginConfigs The list of plugin configs
   * @returns {Array}
   *
   */


  media_player_config_createClass(MediaPlayerConfig, [{
    key: "getPluginConfigs",
    value: function getPluginConfigs(pluginConfigs) {
      var plugins = [];
      pluginConfigs.forEach(function (pluginConfigJson) {
        plugins.push(new plugin_config(pluginConfigJson));
      });
      return plugins;
    }
  }]);

  return MediaPlayerConfig;
}();

/* harmony default export */ var media_player_config = (media_player_config_MediaPlayerConfig);
// CONCATENATED MODULE: ./src/js/plugin/plugin-manager.js
function plugin_manager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function plugin_manager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function plugin_manager_createClass(Constructor, protoProps, staticProps) { if (protoProps) plugin_manager_defineProperties(Constructor.prototype, protoProps); if (staticProps) plugin_manager_defineProperties(Constructor, staticProps); return Constructor; }


/**
 *
 * @module PluginManager
 * @desc Manages the creation of player plugins
 * @class PluginManager
 *
 */

var plugin_manager_PluginManager =
/*#__PURE__*/
function () {
  /**
   *
   * @constructor
   * @param config {MediaPlayerConfig}
   * @param observationCenter {ObservationCenter}
   *
   */
  function PluginManager(config, observationCenter) {
    plugin_manager_classCallCheck(this, PluginManager);

    /**
     *
     * @type {MediaPlayerConfig}
     *
     */
    this.config = config;
    /**
     *
     * @desc Reference to the @link ObservationCenter
     * @type {ObservationCenter}
     *
     */

    this.observationCenter = observationCenter;
    /**
     *
     * @desc List of plugins that have been creatd for the player
     * @type {Array}
     *
     */

    this.plugins = [];
    /**
     *
     * @desc Map of available plugins
     * @type {object}
     *
     */

    this.pluginsMap = {};
    this.createPlugins();
  }
  /**
   *
   * @desc Creates the plugins specified in the pluginConfigs list
   *
   */


  plugin_manager_createClass(PluginManager, [{
    key: "createPlugins",
    value: function createPlugins() {
      var _this = this;

      var pluginConfigList = this.config.pluginConfigs;

      if (pluginConfigList.length) {
        pluginConfigList.forEach(function (pluginConf) {
          try {
            var newPlugin = new pluginConf.pluginReference(pluginConf.config, _this.observationCenter);

            _this.plugins.push({
              plugin: newPlugin
            });

            _this.pluginsMap[get_default()(pluginConf, 'config.name')] = newPlugin;
          } catch (error) {
            throw error;
          }
        });
      }
    }
    /**
     *
     * @desc Gets a reference to the plugin by name
     * @param {string} pluginName
     *
     */

  }, {
    key: "getPlugin",
    value: function getPlugin(pluginName) {
      return this.pluginsMap[pluginName];
    }
  }]);

  return PluginManager;
}();

/* harmony default export */ var plugin_manager = (plugin_manager_PluginManager);
// CONCATENATED MODULE: ./src/js/comm/observation-center.js
function observation_center_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/**
 *
 * @module ObservationCenter
 * @desc Container for observable BehaviorSubjects (@see https://rxjs-dev.firebaseapp.com/api/index/class/BehaviorSubject)
 * @class ObservationCenter
 *
 */

var observation_center_ObservationCenter = function ObservationCenter() {
  observation_center_classCallCheck(this, ObservationCenter);

  /**
   *
   * @desc Observable subject for the player's state
   * @type {Rxjs.BehaviorSubject}
   *
   */
  this.stateSubject = new external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_["BehaviorSubject"]({
    type: 'empty'
  });
  /**
   *
   * @desc Observable subject for the player
   * @type {Rxjs.BehaviorSubject}
   *
   */

  this.playerSubject = new external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_["BehaviorSubject"]({
    type: 'empty'
  });
  /**
   *
   * @desc Observable subject for the player time updates
   * @type {Rxjs.BehaviorSubject}
   *
   */

  this.playerTimeSubject = new external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_["BehaviorSubject"]({
    type: 'empty'
  });
  /**
   *
   * @desc Observable subject for plugins
   * @type {Rxjs.BehaviorSubject}
   *
   */

  this.pluginSubject = new external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_["BehaviorSubject"]({
    type: 'empty'
  });
  /**
   *
   * @desc Observable subject for controls
   * @type {Rxjs.BehaviorSubject}
   *
   */

  this.controlsSubject = new external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_["BehaviorSubject"]({
    type: 'empty'
  });
};

/* harmony default export */ var observation_center = (observation_center_ObservationCenter);
// CONCATENATED MODULE: ./src/js/player/media-player.js
function media_player_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function media_player_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function media_player_createClass(Constructor, protoProps, staticProps) { if (protoProps) media_player_defineProperties(Constructor.prototype, protoProps); if (staticProps) media_player_defineProperties(Constructor, staticProps); return Constructor; }









/**
 *            .--.                  Try not.
 * ::\`--._,'.::.`._.--'/::     Do or do not.
 * ::::.  ` __::__ '  .::::    There is no try.
 * ::::::-:.`'..`'.:-::::::
 * ::::::::\ `--' /::::::::              -Yoda
 *
 */

/**
 *
 * @module MediaPlayer
 * @desc The base level object for Player access
 *
 */

var media_player_MediaPlayer =
/*#__PURE__*/
function () {
  /**
   *
   * @constructor
   * @param {MediaPlayerConfig} config The MediaPlayerConfig for the player/
   *
   */
  function MediaPlayer() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new media_player_config();

    media_player_classCallCheck(this, MediaPlayer);

    /**
     *
     * @type {ObservationCenter}
     *
     */
    this.observationCenter = new observation_center();
    /**
     *
     * @type {MediaPlayerConfig}
     * @desc Reference to the MediaPlayerConfig object used to create the player
     *
     */

    this.config = undefined;
    /**
     *
     * @type {PluginManager}
     *
     */

    this.pluginManager = undefined;
    /**
     *
     * @type {AbstractPlayer}
     * @desc This is a reference to the player created based on MediaPlayerConfig
     *
     */

    this.player = this.createPlayer(config);
    /**
     *
     * @type {MediaItem}
     * @desc The currently assigned MediaItem
     *
     */

    this.currentMediaItem = undefined;
  }
  /**
   *
   * @desc Sets the config property and creates the plugin manager
   * @param {MediaPlayerConfig} config
   * @todo clean up existing pluginManager?
   *
   */


  media_player_createClass(MediaPlayer, [{
    key: "initConfig",
    value: function initConfig(config) {
      if (!(config instanceof media_player_config)) {
        throw new Error('Config must be a MediaPlayerConfig object. For more information please see https://github.mlbam.net/pages/web-media/mlb-media-player/manual/examples.html');
      }

      this.currentMediaItem = get_default()(this.config, 'mediaItem');
      this.config = config;
      this.pluginManager = new plugin_manager(this.config, this.observationCenter);
    }
    /**
     *
     * @desc Initializes the player & returns a Promise
     * @returns {Promise}
     *
     */

  }, {
    key: "initPlayer",
    value: function initPlayer() {
      return this.player.initPlayer();
    }
    /**
     *
     * @param {MediaPlayerConfig} config (Optional) The MediaPlayerConfig object
     * @returns {AbstractPlayer} The player instance
     *
     */

  }, {
    key: "createPlayer",
    value: function createPlayer(config) {
      if (config) {
        this.initConfig(config);
      }

      this.player = player_factory.create(this.config, this.observationCenter); // Notify player created

      this.observationCenter.playerSubject.next(new messages.BaseMessage(media_player_events.MEDIA_PLAYER_CREATED, this));
      return this.player;
    }
  }, {
    key: "canPlayNewMediaItem",
    value: function canPlayNewMediaItem(mediaItem) {
      var deviceInfo = get_default()(this.config, 'playerTypeConfig.deviceInfo');

      var srcPlayerType = player_factory.getPlayerTypeFromSource(mediaItem.src, deviceInfo);

      var currentPlayerType = get_default()(this.player, 'playerTypeConfig.playerType');

      var canPlay = srcPlayerType === currentPlayerType;
      return canPlay;
    }
    /**
     *
     * @desc Resets the playerType config destroys the current player and creates
     * a new player to handle playback of the the provided MediaItem.
     * @param {MediaItem} mediaItem The new mediaItem
     * @returns {Promise} the `initPlayer()` promise
     * @private
     *
     */

  }, {
    key: "createNewPlayerForMediaItem",
    value: function createNewPlayerForMediaItem(mediaItem) {
      // Remove the initial meidaItem is there was one
      this.config.playerTypeConfig.mediaItem = mediaItem; // Destroy the player

      this.player.destroy();
      this.player = undefined; // Create a new player, don't pass the config so the plugins aren't recreated

      this.createPlayer(); // Init that player and then send the new media item

      return this.initPlayer().catch(function (error) {
        logger.error(error);
        return error;
      });
    }
    /**
     *
     * @desc Sets the source, vtt tracks and poster of the media to playback
     * @param {MediaItem} mediaItem The MediaItem representing the media to playback
     *
     */

  }, {
    key: "setMediaItem",
    value: function setMediaItem(mediaItem) {
      var currentSrc = get_default()(this.currentMediaItem, 'src');

      var newSrc = get_default()(mediaItem, 'src');

      if (currentSrc !== newSrc) {
        this.currentMediaItem = mediaItem;

        if (this.player && this.canPlayNewMediaItem(mediaItem)) {
          this.player.open(mediaItem);
          return Promise.resolve();
        } else if (this.player && !this.canPlayNewMediaItem(mediaItem)) {
          return this.createNewPlayerForMediaItem(mediaItem);
        }
      } else {
        logger.info('Already playing this mediaItem');
        logger.info('Current MediaItem', this.currentMediaItem);
        logger.info('New MediaItem', mediaItem);
        return Promise.resolve();
      }
    }
    /**
     *
     * @desc Set poster for video player
     * @param {string} imgUrl Image path/url
     * @memberof MediaPlayer
     *
     */

  }, {
    key: "setPoster",
    value: function setPoster(imgUrl) {
      this.config.poster = imgUrl;
      this.player.setPoster(imgUrl);
    }
    /**
     *
     * @desc Pause the media when in a playing state
     *
     */

  }, {
    key: "pause",
    value: function pause() {
      this.player.pause();
    }
    /**
     *
     * @desc Play the media from a paused or stopped state
     *
     */

  }, {
    key: "play",
    value: function play() {
      this.player.play();
    }
    /**
     *
     * @desc Replay the media
     *
     */

  }, {
    key: "replay",
    value: function replay() {
      this.player.replay();
      this.observationCenter.playerSubject.next(new messages.BaseMessage(media_player_events.MEDIA_REPLAY, this));
    }
    /**
     *
     * @desc Seeks to a specific time
     * @param {Number} time the time in seconds to seek to
     *
     */

  }, {
    key: "seek",
    value: function seek(time) {
      this.player.seek(time);
    }
    /**
     *
     * @desc Mutes the player
     *
     */

  }, {
    key: "mute",
    value: function mute() {
      this.player.mute();
    }
    /**
     *
     * @desc Un-mutes the player
     *
     */

  }, {
    key: "unMute",
    value: function unMute() {
      this.player.unMute();
    }
    /**
     *
     * @desc Seeks to a specific time
     * @param {Number} time the time in seconds to seek to
     *
     */

  }, {
    key: "jumpToLive",
    value: function jumpToLive(time) {
      this.player.jumpToLive(time);
    }
    /**
     *
     * @desc Sets the volume.
     * @param {number} volume a value between 0 and 1
     *
     */

  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.player.setVolume(volume);
    }
    /**
     *
     * @desc Request fullscreen for the specified DOM element
     * @param {*} element The DOM element to target for fullscreen
     *
     */

  }, {
    key: "requestFullscreen",
    value: function requestFullscreen(element) {
      this.player.requestFullscreen(element);
    }
    /**
     *
     * @desc Exit fullscreen
     *
     */

  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      this.player.exitFullscreen();
    }
    /**
     *
     * @desc Sets isAdPlaying on the state and updates any observers
     * @param {boolean} value if an ad is playing or not
     *
     */

  }, {
    key: "setIsAdPlaying",
    value: function setIsAdPlaying(value) {
      this.player.setIsAdPlaying(value);
    }
    /**
     *
     * @desc Remove default controls attr
     *
     */

  }, {
    key: "removeDefaultControls",
    value: function removeDefaultControls() {
      this.player.removeDefaultControls();
    }
    /**
     *
     * @desc {int} index indicate the player to display captions/subtitles
     *
     */

  }, {
    key: "showClosedCaptions",
    value: function showClosedCaptions(index) {
      this.player.showClosedCaptions(index);
    }
    /**
     *
     * @desc indicate the player to hide captions/subtitles
     *
     */

  }, {
    key: "hideClosedCaptions",
    value: function hideClosedCaptions() {
      this.player.hideClosedCaptions();
    }
    /**
     *
     * @desc Getter for the Log util
     *
     */

  }, {
    key: "Log",
    get: function get() {
      return logger;
    }
  }]);

  return MediaPlayer;
}();

/* harmony default export */ var media_player = (media_player_MediaPlayer);
// CONCATENATED MODULE: ./src/js/plugin/plugin-events.js
/**
 *
 * @module Basic plugin events enum
 * @desc Baes plugin event enumeration
 *
 */
/* harmony default export */ var plugin_events = ({
  READY: 'pluginReady'
});
// CONCATENATED MODULE: ./src/js/plugin/abstract-plugin.js
function abstract_plugin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function abstract_plugin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function abstract_plugin_createClass(Constructor, protoProps, staticProps) { if (protoProps) abstract_plugin_defineProperties(Constructor.prototype, protoProps); if (staticProps) abstract_plugin_defineProperties(Constructor, staticProps); return Constructor; }





/**
 *
 * @module AbstractPlugin
 * @desc
 * @class AbstractPlugin
 *
 */

var abstract_plugin_AbstractPlugin =
/*#__PURE__*/
function () {
  /**
   *
   * @constructor
   * @param {PluginConfig} config
   * @param {BehaviorSubject} pluginSubject
   *
   */
  function AbstractPlugin(config, observationCenter) {
    abstract_plugin_classCallCheck(this, AbstractPlugin);

    /**
     *
     * @type {PluginConfig}
     *
     */
    this.config = config;
    /**
     *
     * @type {BehaviorSubject}
     *
     */

    this.observationCenter = observationCenter;
    /**
     *
     * @type {MediaPlayer}
     *
     */

    this.mediaPlayer = undefined;
    /**
     *
     * @type {Subscription[]}
     *
     */

    this.subscriptions = [];
    this.subscribe();
  }
  /**
   *
   * @desc subscribe to player data streams
   *
   */


  abstract_plugin_createClass(AbstractPlugin, [{
    key: "subscribe",
    value: function subscribe() {
      var _this = this;

      this.subscriptions.push(this.observationCenter.playerSubject.subscribe(function (state) {
        switch (get_default()(state, 'type')) {
          case media_player_events.MEDIA_PLAYER_CREATED:
            {
              _this.setMediaPlayer(state.mediaPlayer);

              break;
            }
        }
      }));
    }
    /**
     *
     * @desc Sends a PluginReadyMessage event
     *
     */

  }, {
    key: "pluginReady",
    value: function pluginReady() {
      this.observationCenter.pluginSubject.next(new plugin_ready_message(plugin_events.READY, this));
    }
    /**
     *
     * @desc Sets the mediaPlayer reference on the plugin
     * @param {MediaPlayer} mediaPlayer
     *
     */

  }, {
    key: "setMediaPlayer",
    value: function setMediaPlayer(mediaPlayer) {
      this.mediaPlayer = mediaPlayer;
      this.pluginReady();
    }
    /**
     *
     * @desc Release allocated resources
     *
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
  }]);

  return AbstractPlugin;
}();

/* harmony default export */ var abstract_plugin = (abstract_plugin_AbstractPlugin);
// CONCATENATED MODULE: ./src/js/enums/plugin-type.js
/**
 *
 * @module PluginType enum
 * @desc Plugin type enumeration
 *
 */
/* harmony default export */ var plugin_type = ({
  ADVERTISING: 'ADVERTISING',
  ANALYTICS: 'ANALYTICS',
  COMMUNICATION: 'COMMUNICATION'
});
// CONCATENATED MODULE: ./src/js/entry.js
/* concated harmony reexport MediaPlayer */__webpack_require__.d(__webpack_exports__, "MediaPlayer", function() { return media_player; });
/* concated harmony reexport MediaItem */__webpack_require__.d(__webpack_exports__, "MediaItem", function() { return media_item; });
/* concated harmony reexport PlayerType */__webpack_require__.d(__webpack_exports__, "PlayerType", function() { return player_type; });
/* concated harmony reexport MediaPlayerConfig */__webpack_require__.d(__webpack_exports__, "MediaPlayerConfig", function() { return media_player_config; });
/* concated harmony reexport PlayerTypeConfig */__webpack_require__.d(__webpack_exports__, "PlayerTypeConfig", function() { return player_type_config; });
/* concated harmony reexport HLSJSPlayerConfig */__webpack_require__.d(__webpack_exports__, "HLSJSPlayerConfig", function() { return hlsjs_player_config; });
/* concated harmony reexport MediaConfigUtil */__webpack_require__.d(__webpack_exports__, "MediaConfigUtil", function() { return media_config_util; });
/* concated harmony reexport Log */__webpack_require__.d(__webpack_exports__, "Log", function() { return logger; });
/* concated harmony reexport AbstractPlugin */__webpack_require__.d(__webpack_exports__, "AbstractPlugin", function() { return abstract_plugin; });
/* concated harmony reexport PluginType */__webpack_require__.d(__webpack_exports__, "PluginType", function() { return plugin_type; });
/* concated harmony reexport MediaPlayerEvents */__webpack_require__.d(__webpack_exports__, "MediaPlayerEvents", function() { return events; });
/* concated harmony reexport PluginEvents */__webpack_require__.d(__webpack_exports__, "PluginEvents", function() { return plugin_events; });
/* concated harmony reexport Messages */__webpack_require__.d(__webpack_exports__, "Messages", function() { return messages; });
/* concated harmony reexport FeatureDetection */__webpack_require__.d(__webpack_exports__, "FeatureDetection", function() { return feature_detection; });
/**
 *
 * @module entry
 * @desc MediaPlayer entry point
 *
 */















/***/ })
/******/ ]);
});
//# sourceMappingURL=media-player.js.map